import  './MonacoEditor.css';
import './CreateTemplate.css';
import React, { useState, useRef, useEffect, useImperativeHandle,forwardRef } from 'react';
import ContextMenu from './ContextMenu';
import Canvas from './Canvas';
import Util from './Util';
import Swal from 'sweetalert2';
import RibbonMenu from './RibbonMenu';
import RichTextEditor from './RichTextEditor';
import MenuPageModal from './MenuPageModal';
import SegmentsOptionsModal from './SegmentsOptionsModal';
import HtmlEditor from './HtmlEditor';
import LinkModal from './LinkModal';
import CopyModal from './CopyModal';
import ImageSelect from './ImageSelect';
import AiPrompt from './AiPrompt';
import {toHtml} from './toHtml';
import SettingsDialog from './SettingsDialog';
import AnimateSettings from './AnimateSettings';
import EffectsDialog from './EffectsDialog';
import SvgGlyphDialog from './SvgGlyphDialog.js';
import ShortCuts from './ShortCuts.js'
import {exportSvg, exportCode, exportRectAsSvg, svgToWebPBlob} from './Funcs.js';

import {HELP_CONTENT, DEFAULT_HELP} from './HelpRegistry';


import {getUnique, isSameLine} from './Funcs';
import {restoreClipBoard} from './ClipBoard'

import {
  FilePlus,
  FolderOpen,
  Upload,
  Download,
  Code,
  Circle,
  CircleDashed,  
  Square,
  PictureInPicture,
  Sparkle,
  CodeXml,
  Play,
  PanelTop,
  PencilLine,
  Signature,
  Share2,
  MousePointer,
  Undo2,
  Redo2,
  Save,
  FileCode,
  Zap,
  Trash2,
  Type,
  Smile,
  ExternalLink,
  Rewind,
  X,
} from 'lucide-react';
import AiEdit from './AiEdit.js';


const DashedRectangleIcon = () => {
  return (
    <div style={{ display: 'inline-block', border: '2px dashed black', padding: '5px' }}>
      
    </div>
  );
};

const iconMap = {
  fileOperations: [
    { icon: <FilePlus size={18} />, title: 'New file', key: 'new' },
    { icon: <FolderOpen size={18} />, title: 'Open file', key: 'open' },
    { icon: <Upload size={18} />, title: 'Export Layout', key: 'export' },
    { icon: <Download size={18} />, title: 'Import Layout', key: 'import' },
  ],
  rectangles: [    
    { icon: 'https://myaiweb.ca/humanhtml.svg', title: 'Human HTML', key: 'rect', type: 'url', hotX:2, hotY:2},
    { icon: 'https://myaiweb.ca/imageicon.svg', title: 'Image Rectangle', key: 'image', type:'url', hotX:22, hotY:18 },
    { icon: 'https://myaiweb.ca/aiart.svg', title: 'AI Art', key: 'aiart', type:'url', hotX:5, hotY:17},  
    { icon: 'https://myaiweb.ca/aihtml.svg', title: 'AI Html', key: 'airect', type: 'url', hotX:2,hotY:2},      
    { icon: 'https://myaiweb.ca/animate.svg', title: 'Simple Animation', key: 'animate', type: 'url', hotX:2, hotY:2},
    { icon: 'https://myaiweb.ca/text.svg', title: 'Add SVG text', key: 'svgtext', type: 'url', hotX:2, hotY:2},
    { icon: 'https://myaiweb.ca/smiley.svg', title: 'Add SVG emoji', key: 'svgemoji', type: 'url', hotX:0, hotY:0},
    { icon: 'https://myaiweb.ca/circle.svg', title: 'SVG Circle', key: 'svgcircle',type: 'url', hotX:2, hotY:2},    
    { icon: 'https://myaiweb.ca/ellipse.svg', title: 'SVG Ellipse', key: 'svgellipse',type: 'url', hotX:2, hotY:2 },
    { icon: 'https://myaiweb.ca/square.svg', title: 'SVG Square', key: 'svgsquare',type: 'url', hotX:2, hotY:2 },
    { icon: 'https://myaiweb.ca/rectangle.svg', title: 'SVG Rectangle', key: 'svgrect',type: 'url', hotX:2, hotY:2 },
  ],
  drawing: [
    { icon: <PencilLine size={18} />, title: 'Draw line (polyline)', key: 'pline' },
    { icon: <Signature size={18} />, title: 'Freehand draw', key: 'freehand' },
    { icon: <Share2 size={18} />, title: 'Draw Bezier curve', key: 'bezier' },
  ],
  undoRedoClear: [
    { icon: <Undo2 size={18} />, title: 'Undo last action', key: 'undo' },
    { icon: <Redo2 size={18} />, title: 'Redo last undo', key: 'redo' },
    { icon: <Trash2 size={18} />, title: 'Clear canvas', key: 'clear' },
  ],
  previewSite: [
    
    { icon: <ExternalLink size={18} />, title: 'Render Website', key: 'preview' },
    { icon: <Code size={18} />, title: 'View Generated HTML code', key: 'previewCode' },
  ],
  save: [
    { icon: <Save size={18} />, title: 'Save AIT file', key: 'save' },      
  ],
};

/*
const iconMap = {
  new: { icon: <FilePlus size={18} />, title: 'New file' },
  open: { icon: <FolderOpen size={18} />, title: 'Open file' },
  rect: { icon: <Square size={18} />, title: 'HTML rectangle' },
  image: { icon: <PictureInPicture size={18} />, title: 'Image rectangle' },
  airect:{ icon: <Sparkle size={18} />, title: 'AI rectangle' }, 
  svgtext: { icon: <Type size={18} />, title: "Add text" },  
  pline: { icon: <PencilLine size={18} />, title: 'Draw line (polyline)' },
  freehand: { icon: <Signature size={18} />, title: 'Freehand draw' },
  bezier: { icon: <Activity size={18} />, title: 'Draw Bezier curve' },
  select: { icon: <MousePointer size={18} />, title: 'Select / Pan / Idle' },
  undo: { icon: <Undo2 size={18} />, title: 'Undo last action' },
  redo: { icon: <Redo2 size={18} />, title: 'Redo last undo' },
  clear: { icon: <Trash2 size={18} />, title: 'Clear canvas' },
  preview: { icon: <ExternalLink size={18} />, title: 'Open preview in new tab' },
  save: { icon: <Save size={18} />, title: 'Save AIT file' },
  savehtml: { icon: <FileCode size={18} />, title: 'Save HTML file' },
  saveai: { icon: <Zap size={18} />, title: 'Save AI Generated HTML' },
};
*/

const iconMapDraw = {
  restore: {icon: <Rewind size = {18} />, title: 'Restore from last session'},
  newline: { icon: <FilePlus size={18} />, title: 'Start new line' },
  undoline: { icon: <Undo2 size={18} />, title: 'Undo line operation' },
  clearlines: { icon: <Trash2 size={18} />, title: 'Clear drawing' },
  finalize: { icon: <Save size={18} />, title: 'Finalize drawing into recangle' },
  exitline: { icon: <X size={18} />, title: 'Exit Operation' },
}

const CreateTemplate = ({auth, onLogout, onAuth, demo}) => {
  const [operation, setOperation] = useState('select');  
  const [coords, setCoords] = useState({ x: 0, y: 0 });
  const [selectedRect, setSelectedRect] = useState([]);
  const [canUndo, setCanUndo] = useState(false);
  const [canRedo, setCanRedo] = useState(false);
  const [canSave, setCanSave] = useState(false);
  const [dataChanged,setDataChanged] = useState(false);
  const [activeHelpKey, setActiveHelpKey] = useState(null);
  const [showShortCuts, setShowShortCuts] = useState(false);
  const hoverTimer = useRef(null);



  const handleEnter = (e) => {

    if(operation === 'select')
    {
        const helpKey = e.currentTarget.dataset.help + "_hover";
        setActiveHelpKey(helpKey);  // Immediately set the helpKey when entering
        // Clear any previous timer before setting a new one
        clearTimeout(hoverTimer.current);
        hoverTimer.current = setTimeout(() => {
          setActiveHelpKey(helpKey);  // Set the correct helpKey after the timeout
        }, 250);
    }
  };
  
  const handleLeave = () => {
    if(operation === 'select')
    {
      // Clear the active help key when leaving
      setActiveHelpKey(null);
      // Clear any previous timer and set a new one
      clearTimeout(hoverTimer.current);
      hoverTimer.current = setTimeout(() => {
        setActiveHelpKey(null);  // Reset the help key after delay
      }, 1000);
    }
  };
  
  const setCanSaveFunc = (flag) =>
  {
    canSaveRef.current = flag;
  }

  const [rectData, setRectData] = useState({
    id: '',
    description: '',
    type: '',
  });

  const [canvasKey, setCanvasKey] = useState(0);
  const [refreshKey, setRefreshKey] = useState(0);
  const [refreshToggle, setRefreshToggle] = useState(false);
  const [filename, setFilename] = useState('');
  const [fileList, setFileList] = useState([]);  // To store list of HTML filenames
  const [isModalOpen, setIsModalOpen] = useState(false);  // For showing the modal
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);  // For showing the modal
  const [isHtmlEditorOpen, setIsHtmlEditorOpen] = useState(false);
  const [isLinkModalOpen, setIsLinkModalOpen] = useState(false);
  const [isCopyModalOpen, setIsCopyModalOpen] = useState(false);
  const [isImageSelectOpen, setIsImageSelectOpen] = useState(false);
  const [isScrollOpen, setIsScrollOpen] = useState(false);
  const [isAiPromptOpen, setIsAiPromptOpen] = useState(false);
  const [isAiEditOpen, setIsAiEditOpen] = useState(false);
  const [promptType, setPromptType] = useState("vector");
  const [selectedFile, setSelectedFile] = useState(null);  // To store the currently selected file  
  const [isWaitingForFiles, setIsWaitingForFiles] = useState(false);
  const [loadingFile, setLoadingFile] = useState(null);
  const [contextMenu, setContextMenu] = useState(null);  
  const [pageWidth, setPageWidth] = useState(432);     //0,480 // 481,768 // 769, 1024 //  1025,1440 //1441,1920
  const [pageWidthStr, setPageWidthStr] = useState("432");
  const [pageHeight, setPageHeight] = useState(932);   //640,900
  const [pageHeightStr, setPageHeightStr] = useState("");
  const [gridWidth, setGridWidth] = useState(20);
  const [gridHeight, setGridHeight] = useState(20);
  const [stroke, setStroke] = useState(1);
  const [strokeColor, setStrokeColor] = useState('#000000');
  const [fillColor, setFillColor] = useState('#FFFFFF');
  const [snapToGrid, setSnapToGrid] = useState(false);
  const [showEndPoints, setShowEndPoints] = useState(true);
  const [showControls, setShowControls] = useState(true);
  const [enableStroke, setEnableStroke] = useState(true);
  const [enableFill, setEnableFill] = useState(false);
  const [fillMode, setFillMode] = useState("solid");  
  const [gradientColor1, setGradientColor1] = useState('#000000');
  const [gradientColor2, setGradientColor2] = useState('#FFFFFF');
  const [gradientAngle, setGradientAngle] = useState(0)
  const [alpha, setAlpha] =  useState(1);
  const [clipBoard, setClipBoard] = useState(true);
  const [method, setMethod] =  useState("scroll");
  const  [lockAspect, setLockAspect] = useState(false);
  

  const [currentPage, setCurrentPage] =  useState(0);
  const [totalPages, setTotalPages] =  useState(0);
  const [pageId, setPageId]=useState('');
  const [deviceId, setDeviceId] = useState('');
  const [unique,setUnique] = useState(0);


  const [menuModalOpen, setMenuModalOpen] = useState(false);

  const pagesRef  =  useRef({});
  const canvasRef = useRef();
  const onClipBoardRef =  useRef(false);
  const canSaveRef = useRef(false);

  const selectedRectRef = useRef([])
  const pSegmentsRef = useRef([]);
  const pASegmentRef = useRef(null);
  const pLinesRef = useRef(null);
  
  const segmentOpRef = useRef("none");
  const pauseDeleteRef = useRef(false);
  const isAiPromptOpenRef = useRef(false);  
  const isHtmlEditorOpenRef = useRef(false);
  const isLinkModalOpenRef = useRef(false);
  const isAiEditOpenRef = useRef(false);  
  const isCopyModalOpenRef  = useRef(false);  
  
  
  const animateOpRef = useRef("none");
  const altKeyUp = useRef(false);
  
  /*
  const menuInfoRef = useRef({
                        name: "",
                        slug: "",
                        order: 1,
                        visibleInMenu: true,
                        menuType: "top",
                        icon: "",
                        menuVisibility: {
                          extraSmall: true,
                          small: true,
                          medium: true,
                          large: true,
                          extraLarge: true,
                        },
                      });
*/                      

  const operationRef = useRef(operation);
  /*
  const devicesRef =  useRef([{name:"extraSmall", minWidth:0, maxWidth:480, minHeight:640, maxHeight:900},
                              {name:"small", minWidth: 481, maxWidth:768, minHeight: 720, maxHeight:1024},
                              {name:"medium",minWidth: 769, maxWidth:1024, minHeight:768, maxHeight:1366},
                              {name:"large", minWidth: 1025, maxWidth:1440, minHeight:800, maxHeight: 1600},
                              {name:"extraLarge",minWidth: 1441, maxWidth:1920, minHeight:900, maxHeight: 2160}]);
*/                              

const devicesRef =  useRef([{name:"extraSmall", minWidth:0, maxWidth:480},
                            {name:"small", minWidth: 481, maxWidth:768},
                            {name:"medium",minWidth: 769, maxWidth:1024},
                            {name:"large", minWidth: 1025, maxWidth:1440},
                            {name:"extraLarge",minWidth: 1441, maxWidth:1920}]);

  const navigationRef = useRef({method:method,
                                menubar: {
                                           visible:false,
                                           rectId: ""
                                        }});                              

  const pagesForDeviceRef = useRef({
                                extraSmall:  [] ,
                                small:  [] ,
                                medium: [],
                                large:  [],
                                extraLarge: []
                              });
              


  const [isSettingDialogOpen, setIsSettingDialogOpen] = useState(false);
  const [isAnimateDialogOpen, setIsAnimateDialogOpen] = useState(false);
  const [isEffectsDialogOpen, setIsEffectsDialogOpen] = useState(false);
  const [isSvgGlyphDialogOpen, setIsSvgGlyphDialogOpen] = useState(false);

  const openSettingDialog = () => 
  {
    pauseDeleteRef.current = true;
    setIsSettingDialogOpen(true);
  }
  const closeSettingDialog = () => {
    pauseDeleteRef.current = false;
    setIsSettingDialogOpen(false);
  }

  const openSvgGlyphDialog = () =>
  {
    pauseDeleteRef.current = true;
    setIsSvgGlyphDialogOpen(true);
  }

  const closeSvgGlyphDialog = () =>
  {
    pauseDeleteRef.current = false;
    setIsSvgGlyphDialogOpen(false);
  }

  const saveNewGlyph = async (glyph) =>
  {    
    await canvasRef.current.updateBezier(selectedRect[0], glyph);
  }

  const handleScrollOpen = (flag) => {
    setIsScrollOpen(flag);
  }
                            
  const handleSettingsSave = (settings) => {
          console.log("File settings saved:", settings);

          setStroke(parseInt(settings.strokeWidth));
          setFillColor(settings.fillColor);
          setStrokeColor(settings.strokeColor);
          setFillMode(settings.fillMode);
          setGradientColor1(settings.gradientColor1);
          setGradientColor2(settings.gradientColor2);
          setGradientAngle(settings.gradientAngle);
      
          let s = selectedRectRef.current[0];
          if(s?.type === "SvgText")
          {
            canvasRef.current.applySvgTextOptions(s);
          }
  
          console.log("Before check");
          if(s?.type === 'Bezier' || s?.type === 'Prect')
          {
      
            canvasRef.current.redraw();
          }
          else
          {
            canvasRef.current.updateLineSettings(settings);    
            canvasRef.current.redraw();
          }          
  };


  const openAnimateDialog = () => 
  {
    setIsAnimateDialogOpen(true);
    pauseDeleteRef.current = true;
  }    
  const closeAnimateDialog = () => {
   
    canvasRef.current.setCursor('select');
    setIsAnimateDialogOpen(false);
    pauseDeleteRef.current = false;
  }
                            
  const handleAnimateSave = (settings) => {
          console.log("File settings saved:", settings);

          let s = selectedRectRef.current[0];
          if(s?.subType === "Animate")
          {
            s.animationSettings = settings;
            setIsAnimateDialogOpen(false);
            canvasRef.current.redraw();
  
          }
  };

  const openEffectsDialog = () =>
  {
      pauseDeleteRef.current = true;
      setIsEffectsDialogOpen(true);
  }

  const closeEffectsDialog = () => {
   
    pauseDeleteRef.current = false;
    canvasRef.current.setCursor('select');
    setIsEffectsDialogOpen(false);
  }
                            
  const handleEffectsSave = (settings) => {
    // console.log("File settings saved:", settings);   
        
    canvasRef.current.redraw();      
  };


  const handleMPathSelection = () =>
  {

    let cp = pagesRef.current.pages[currentPage-1];

    let found = cp.layout.find((r)=>{

            if(r.type === 'Bezier' || r.type === 'Prect')
            {
              return true;
            }

          })
    if(!found) 
    {
      Swal.fire({
        title: 'Info',
        text: "No selectable path found in current drawing. Please draw and then select",
        icon: 'info',
        confirmButtonText: 'OK',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,    
      });          
      return;
    }         
    console.log ("Select m path");
    setIsAnimateDialogOpen(false);
    animateOpRef.current="selectMPath";
    canvasRef.current.setCursor('crosshair');
    canvasRef.current.redraw();
  }


  const handleResizeView = () =>
  {

    setIsAnimateDialogOpen(false);
    animateOpRef.current="resizeView";
    canvasRef.current.setCursor('nwse-resize');
    canvasRef.current.resizeView(true);
    canvasRef.current.redraw();
  
  }

  const handleOffsetPath = () =>
  {
    setIsAnimateDialogOpen(false);
    animateOpRef.current="handleOffsetPath";
    canvasRef.current.setCursor('crosshair');
    canvasRef.current.redraw();
  }

  const handleOffsetObj = () =>
  {
    
    setIsAnimateDialogOpen(false);
    animateOpRef.current="handleOffset";
    canvasRef.current.setCursor('crosshair');
    canvasRef.current.redraw();

  }

  const handleMObjectSelection = () =>
  {

    let cp = pagesRef.current.pages[currentPage-1];
    let found = cp.layout.find((r)=>{

      if(r.type === 'Bezier' || r.type === 'Prect' || r.type === 'SvgText' || r.type === 'SvgEmoji')
      {
        return true;
      }

    })
    if(!found) 
    {
      Swal.fire({
        title: 'Info',
        text: "No selectable motion object found on current drawing. Please draw and then select",
        icon: 'info',
        confirmButtonText: 'OK',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,    
      });          
      return;
    }         

    console.log ("Select m object");
    setIsAnimateDialogOpen(false);
    animateOpRef.current="selectMObj";
    canvasRef.current.setCursor('crosshair');
    canvasRef.current.redraw();

    console.log ("Select m object");
  }



  const handleLinkModal = () =>
  {
    setIsLinkModalOpen(true);
    pauseDeleteRef.current = true;
    isLinkModalOpenRef.current = true;

  }
  const handleCopyModal = () =>
  {
    setIsCopyModalOpen(true);
    isCopyModalOpenRef.current = true;
    pauseDeleteRef.current = true;
  }

  const handleHtmlEditor = () =>
  {
    setIsHtmlEditorOpen(true);
    isHtmlEditorOpenRef.current = true;
    pauseDeleteRef.current = true;
  }

  const handleAiEdit = () =>
  {
    setIsAiEditOpen(true);
    isAiEditOpenRef.current = true;
    pauseDeleteRef.current = true;
  }
  const handleAiPrompt = (promptType) =>
  {
    // setIsImagePrompt(promptType);
    setPromptType(promptType);
    setIsAiPromptOpen(true);
    isAiPromptOpenRef.current = true;
    pauseDeleteRef.current = true;
  }

  const handleImageSelect = (flag) =>
  {
    if(flag === true)
    {
      let cr=selectedRectRef.current[0];
      cr.keepAspect=true;
      setLockAspect(true);

      if (cr.type==="Prect" || cr.type === "Bezier")
      {
        if(cr.rPath.length > 1)
        {
          Swal.fire({
            title: 'Error',
            text: "Only Single connected polyline or bezier can be used for clip region",
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,    
          });          
          return;
        }
      }
    }
    else
    {
      setLockAspect(false);
    }
    setIsImageSelectOpen(true);
  }

  const onApplyLinkModal = (options) =>
  {
    console.log(JSON.stringify(options));
    setDataChanged(true);
    setIsLinkModalOpen(false);
    isLinkModalOpenRef.current = false;
    pauseDeleteRef.current = false;
    canvasRef.current.redraw();
  }


  const onApplyCopyModal = (options) =>
  {
    console.log(JSON.stringify(options));

    const page = pagesRef.current.pages.find(page=>page.pageId === options.pageSelection);

    if(page != undefined)
    {
      canvasRef.current.duplicatePage(page.layout);    
      setDataChanged(true);
      setIsCopyModalOpen(false);
      isCopyModalOpenRef.current = false;
      pauseDeleteRef.current = false;
      canvasRef.current.redraw();
    }
  }



  const onApplyHtmlEditor = (options) =>
  {
    setDataChanged(true);
    setIsHtmlEditorOpen(false);
    isHtmlEditorOpenRef.current = false;
    pauseDeleteRef.current = false;
    canvasRef.current.redraw();
  }

  const onApplyImagePrompt = async (options) =>
  {
    const applyAiCommand =  async (cmd, imageName) => 
    {
      
      let command = Util.serverName + "/protected/aiNewImage";

      try {
        const response = await fetchWithAuth(command, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({chatMsg:cmd,  referenceImage: imageName}),
        });
  
        const data = await response.json();
  
        if (!response.ok) {
          throw new Error(data.message || `Image generation failed (${response.status}`);

        }
  
        if (!data.status) {
          throw new Error(data.message || "Image generation failed");
        }

        selectedRectRef.current[0].imageName = data.message;
        console.log("Got new Image: ", data.message);
        
        let newAuth = {authenticated:true, user:data.user, globals:data.globals};
        onAuth(newAuth);
  
        canvasRef.current.convertToImage(selectedRectRef.current);

      }
      catch(e)
      {
        console.log("Error sending ai prompt: ", e);
        Swal.fire({
          icon: 'error',
          title: 'Image Generation Failed',
          text: e.message || 'Unable to generate the image.'
        });
      }
      finally
      {
        setDataChanged(true);    
        setIsAiPromptOpen(false);
        console.log("isAiPromptOpen should be false now");
        pauseDeleteRef.current = false;
        canvasRef.current.redraw();  
      }  
    }

    const modifyAiCommand =  async (cmd, imageName, referenceImage) => 
    {
      
      try 
      {
        let type = "art";
        let webp=null;
        let svg = null;

        if(selectedRectRef.current[0].type === 'Bezier')
        {
          type = "bezier";
          svg = exportRectAsSvg(selectedRectRef.current[0]);
          webp = await svgToWebPBlob(svg);
        }
      
        let response = null;
        if(type === "art")
        {

            let command = Util.serverName + "/protected/aiModifyImage";


            response = await fetchWithAuth(command, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({chatMsg:cmd,  imageName: imageName, referenceImage: referenceImage})
              });
        }
        else
        {
          let command = Util.serverName + "/protected/aiModifyImageMulti";
          try {
            const formData = new FormData();
        
            formData.append("chatMsg", cmd);
            formData.append("imageName", imageName);
            formData.append("referenceImage", referenceImage);
            formData.append("svg", svg);
            formData.append("webp", webp, "reference.webp");
        
            response = await fetchWithAuth(command, {
                method: "POST",
                body: formData
            });
          } catch (error) {
            console.error(error);
           }
        }
        
        const data = await response.json();
  
        if (!response.ok) {
          throw new Error(data.message || `Image generation failed (${response.status}`);

        }
  
        if (!data.status) {
          throw new Error(data.message || "Image generation failed");
        }

        if(type === "art")
        {

            // selectedRectRef.current[0].imageName = data.message;
            console.log("Got new Image: ", data.message);            
            // canvasRef.current.convertToImage(selectedRectRef.current);
            canvasRef.current.addNewImage(selectedRectRef.current, data.message);
        }
        else
        {
          canvasRef.current.addNewImage(selectedRectRef.current, data.message);
        }

        let newAuth = {authenticated:true, user:data.user, globals:data.globals};
        onAuth(newAuth);


      }
      catch(e)
      {
        console.log("Error sending ai prompt: ", e);
        Swal.fire({
          icon: 'error',
          title: 'Image Generation Failed',
          text: e.message || 'Unable to generate the image.'
        });
      }
      finally
      {
        setDataChanged(true);    
        setIsAiPromptOpen(false);
        isAiPromptOpenRef.current = false;
        console.log("isAiPromptOpen should be false now");
        pauseDeleteRef.current = false;
        canvasRef.current.redraw();  
      }  
    }

    let rect = selectedRectRef.current[0];
    console.log("The reference image: ", options.referenceImage);
    if(rect.subType != "Image" && rect.type != 'Bezier')
    {
      rect.description = options.rect.description;
      await applyAiCommand(rect.description, options.referenceImage);    
    }
    else
    {
      rect.description = options.rect.description;
      console.log("Description: ", rect.description);
      await modifyAiCommand(rect.description, rect.imageName, options.referenceImage);
    }
  
  }

  const onApplyCodePrompt = async (options) =>
  {

    const applyCodeCommand =  async (cmd, imageName, prevCode, includeSvg) => 
    {
      
      try {

        let type = "art";
        let webp=null;
        let svg = null;

        if(selectedRectRef.current[0].type === 'Bezier')
        {
          type = "bezier";
          svg = exportRectAsSvg(selectedRectRef.current[0]);
          webp = await svgToWebPBlob(svg);
        }
      
        let response = null;


        if (type === "art")
        {
          let command = Util.serverName + "/protected/aiCode";
    
          response = await fetchWithAuth(command, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({chatMsg:cmd, prevCode: prevCode, width:selectedRectRef.current[0].w, height: selectedRectRef.current[0].h, referenceImage: imageName, includeSvg:includeSvg}),
          });
        }
        else
        {
          let command = Util.serverName + "/protected/aiCodeMulti";
          try {
            const formData = new FormData();
        
            let maxWidth = pagesRef.current.pages[currentPage-1].pageWidth;   
            let maxHeight = pagesRef.current.pages[currentPage-1].pageHeight;
            formData.append("chatMsg", cmd);
            formData.append("width", selectedRectRef.current[0].w);
            formData.append("height", selectedRectRef.current[0].h);
            formData.append("referenceImage", imageName);
            formData.append("includeSvg",includeSvg);
            formData.append("maxWidth", maxWidth);
            formData.append("maxHeight", maxHeight);
            formData.append("svg", svg);
            formData.append("webp", webp, "reference.webp");
        
            response = await fetchWithAuth(command, {
                method: "POST",
                body: formData
            });
          } catch (error) {
            console.error(error);
          }
        }
  
        const data = await response.json();
  
        if (!response.ok) {
          throw new Error(data.message || `Code generation failed (${response.status}`);

        }
  
        if (!data.status) {
          throw new Error(data.message || `Code generation failed (${response.status}`);          
        }

        let aiResponse = JSON.parse(data.message);


        await Swal.fire({
          title: "AI Response",
          text: aiResponse.statusMsg,
          icon: "info",
          showCancelButton: true,
          confirmButtonText: "Ok",
        });
          
        let newAuth = {authenticated:true, user:data.user, globals:data.globals};
        onAuth(newAuth);

        if(type === "art")
        {
          selectedRectRef.current[0].aiCode = aiResponse.message;
          console.log("Got ai Code: ", data.message);
        }
        else
        {
          canvasRef.current.addNewAiCode(selectedRectRef.current, aiResponse.message, aiResponse.width, aiResponse.height);
        }
        

        // canvasRef.current.convertToBezier(selectedRectRef.current);
        // canvasRef.current.redraw();

      }
      catch(e)
      {
        console.log("Error sending ai prompt: ", e);
        Swal.fire({
          icon: 'error',
          title: 'Code Generation Failed',
          text: e.message || 'Unable to generate the Code.'
        });

      }
      finally
      {
        setDataChanged(true);    
        setIsAiPromptOpen(false);
        isAiPromptOpenRef.current = false;
        console.log("isAiPromptOpen should be false now");
        pauseDeleteRef.current = false;
        canvasRef.current.redraw();  
      }
  
    }

    let rect = selectedRectRef.current[0];
    rect.imageName = options.rect.imageName;
    rect.description = options.rect.description;
    console.log("includeSvg: ", options.includeSvg);
    await applyCodeCommand(rect.description, rect.imageName, rect.aiCode,options.includeSvg);    
  }

  const onApplyEdit = (options) =>
  {
    let rect = selectedRectRef.current[0];
    rect.aiCode = options.rect.aiCode;
    pauseDeleteRef.current = false;
    canvasRef.current.redraw();  

  }

  const onApplyAiPrompt = async (options) =>
  {

    const applyAiCommand =  async (cmd, imageName) => 
    {
      try {
        let type = "art";

        let svg=null;
        let webp=null;

        if(selectedRectRef.current[0].type === 'Bezier')
        {
          type = "bezier";
          svg = exportRectAsSvg(selectedRectRef.current[0]);
          webp = await svgToWebPBlob(svg);
        }
      
        let response = null;
        if(type === "art")
        {
          let command = Util.serverName + "/protected/aiBezier";
          response = await fetchWithAuth(command, {
             method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({chatMsg:cmd, width:selectedRectRef.current[0].w, height: selectedRectRef.current[0].h, referenceImage: imageName, svg:null, webp:null}),
          });
        }
        else
        {
              let command = Util.serverName + "/protected/aiBezierMulti";
              try {
                const formData = new FormData();
            
                let maxWidth = pagesRef.current.pages[currentPage-1].pageWidth;   
                let maxHeight = pagesRef.current.pages[currentPage-1].pageHeight;
                formData.append("chatMsg", cmd);
                formData.append("width", maxWidth);
                formData.append("height", maxHeight);
                formData.append("referenceImage", imageName);
                formData.append("svg", svg);
                formData.append("webp", webp, "reference.webp");
            
                response = await fetchWithAuth(command, {
                    method: "POST",
                    body: formData
                });
            } catch (error) {
                console.error(error);
            }
        }
  
        const data = await response.json();
  
        if (!response.ok) {
            throw new Error(data.message || `Vector generation failed (${response.status}`);
        }
  
        if (!data.status) {
          throw new Error(data.message || `Vector generation failed (${response.status}`);
        }

        
        let aiResponse = JSON.parse(data.message);


        await Swal.fire({
          title: "AI Response",
          text: aiResponse.statusMsg,
          icon: "info",
          showCancelButton: true,
          confirmButtonText: "Ok",
        });
        
        if(type === "art")
        {
          selectedRectRef.current[0].aiSvg = aiResponse.message;
          // selectedRectRef.current[0].aiSvg = data.message;
          console.log("Got ai Svg: ", data.message);
          console.log("aiSvg: ", selectedRectRef.current[0].aiSvg);

          canvasRef.current.convertToBezier(selectedRectRef.current);
        }
        else
        {
          let width = aiResponse.width;
          let height = aiResponse.height;
          canvasRef.current.addNewBezier(selectedRectRef.current, width, height, aiResponse.message)
        }

        let newAuth = {authenticated:true, user:data.user, globals:data.globals};
        onAuth(newAuth);



      }
      catch(e)
      {
        console.log("Error sending ai prompt: ", e);
        Swal.fire({
          icon: 'error',
          title: 'Vector Generation Failed',
          text: e.message || 'Unable to generate the vector.'
        });

      }
      finally
      {
        setDataChanged(true);    
        setIsAiPromptOpen(false);
        isAiPromptOpenRef.current = false;
        console.log("isAiPromptOpen should be false now");
        pauseDeleteRef.current = false;
        canvasRef.current.redraw();  
      }
  
    }

    let rect = selectedRectRef.current[0];
    rect.imageName = options.rect.imageName;
    rect.description = options.rect.description;
    await applyAiCommand(rect.description, rect.imageName);    
  }

  const onApplyImageSelect = (options) =>
  {
    setDataChanged(true);
    setIsImageSelectOpen(false);
    canvasRef.current.redraw();
  }
  
  const handleMenuSave=(formData) =>
  {
    console.log(JSON.stringify(formData));
    const [update, num] = formData.pageId.split("_");

    for (const key in pagesForDeviceRef.current) 
    {
        pagesForDeviceRef.current[key].forEach((device) => {
          const [root, num] = device.id.split("_");
          if(root === update)
          {
            device.name = formData.name;
          }
        })
    }

    pagesRef.current.pages.forEach((page) => {
      const [root, num] = page.pageId.split("_");
      if(root === update)
      {
        page.pageInfo.name = formData.name;
      }
    })

    pagesRef.current.pages[currentPage-1].pageInfo = formData;

    pagesRef.current.pages[currentPage-1].pageInfo.pageTheme = formData.pageTheme;

    
    pagesRef.current.pages[currentPage-1].pageWidth = parseInt(formData.pageWidth);   
    pagesRef.current.pages[currentPage-1].pageHeight = parseInt(formData.pageHeight);   

    setPageWidthExt(parseInt(formData.pageWidth));
    setPageHeight(parseInt(formData.pageHeight));
    finalizePageWidth(parseInt(formData.pageWidth));
    setDataChanged(true);


    // pagesRef.current.pages[currentPage-1].name = formData.name;

    setDataChanged(true);        
    canvasRef.current.setPageInfo(formData);
    canvasRef.current.redraw();
  }

  const setMethodExt = (value) =>
  {
    setMethod(value);
    if(value ==="menu")
    {
      pagesRef.current.navigation.menubar.visible=true;
    }
    else
    {
      pagesRef.current.navigation.menubar.visible=false;
    }

  }

  /*
  useEffect(() => 
  {
    if (!contextMenu) return;

    const preventScroll = (e) => {
        e.preventDefault();
    };

    window.addEventListener('wheel', preventScroll, { passive: false });

    return () => {
        window.removeEventListener('wheel', preventScroll);
    };

  }, [contextMenu]);
  */

  useEffect(() => {
    if (!isLinkModalOpen) return;
    
    const preventScroll = (e) => {
      
        e.preventDefault();
    };
    
    window.addEventListener('wheel', preventScroll, { passive: false });

    return () => {
        window.removeEventListener('wheel', preventScroll);
    };


  },[isLinkModalOpen]);
  
  useEffect(() => {
    if (!isEffectsDialogOpen) return;
    
    const preventScroll = (e) => {
      
        e.preventDefault();
    };
    
    window.addEventListener('wheel', preventScroll, { passive: false });

    return () => {
        window.removeEventListener('wheel', preventScroll);
    };


  },[isEffectsDialogOpen]);


  useEffect(() => {
    if (!isAnimateDialogOpen) return;
    
    const preventScroll = (e) => {
      
        e.preventDefault();
    };
    
    window.addEventListener('wheel', preventScroll, { passive: false });

    return () => {
        window.removeEventListener('wheel', preventScroll);
    };
  },[isAnimateDialogOpen]);


  useEffect(() => {
    if (!isSvgGlyphDialogOpen) return;
    
    const preventScroll = (e) => {
      
      const scrollList = document.getElementById('scroll-list');
      
      // Allow scrolling inside the image list
      
      if (scrollList && scrollList.contains(e.target)) 
      {
          return;
      }

        e.preventDefault();
    };
    
    window.addEventListener('wheel', preventScroll, { passive: false });

    return () => {
        window.removeEventListener('wheel', preventScroll);
    };


  },[  isSvgGlyphDialogOpen, isScrollOpen]);
  

  useEffect(() => {
    if (!isHtmlEditorOpen) return;
    
    const preventScroll = (e) => {
      
      const scrollList = document.getElementById('scroll-list');
      
      // Allow scrolling inside the image list
      
      if (scrollList && scrollList.contains(e.target)) 
      {
          return;
      }

        e.preventDefault();
    };
    
    window.addEventListener('wheel', preventScroll, { passive: false });

    return () => {
        window.removeEventListener('wheel', preventScroll);
    };


  },[  isHtmlEditorOpen]);
  
  useEffect(() => {
    if (!isSettingDialogOpen) return;
    
    const preventScroll = (e) => {
      
      const scrollList = document.getElementById('scroll-list');
      
      // Allow scrolling inside the image list
      
      if (isScrollOpen && scrollList && scrollList.contains(e.target)) 
      {
          return;
      }

        e.preventDefault();
    };
    
    window.addEventListener('wheel', preventScroll, { passive: false });

    return () => {
        window.removeEventListener('wheel', preventScroll);
    };


  },[isSettingDialogOpen, isScrollOpen]);
  

  
  useEffect(() => {
    if (!isImageSelectOpen) return;
    
    const preventScroll = (e) => {
       const scrollList = document.getElementById('scroll-list');
      
      /*
      console.log(
        "Target:", e.target,
        "Inside list:", imageList?.contains(e.target),
        "List open:", isImageListOpen
      );
      */
      // Allow scrolling inside the image list
      
      if (isScrollOpen && scrollList && scrollList.contains(e.target)) 
      {
          return;
      }
      
        e.preventDefault();
    };
    
    window.addEventListener('wheel', preventScroll, { passive: false });

    return () => {
        window.removeEventListener('wheel', preventScroll);
    };


  },[isImageSelectOpen, isScrollOpen]);
  


  useEffect(() => {
    if (!isAiPromptOpen) return;
    
    const preventScroll = (e) => {
      
      const scrollList = document.getElementById('scroll-list');
      
      /*
      console.log(
        "Target:", e.target,
        "Inside list:", imageList?.contains(e.target),
        "List open:", isImageListOpen
      );
      */
      // Allow scrolling inside the image list
      if (isScrollOpen && scrollList && scrollList.contains(e.target)) 
      {
          return;
      }
      

        e.preventDefault();
    };

    
    window.addEventListener('wheel', preventScroll, { passive: false });

    return () => {
        window.removeEventListener('wheel', preventScroll);
    };


  },[isAiPromptOpen, isScrollOpen]);
  
  useEffect(() => {
    if (!isAiEditOpen) return;
    
    const preventScroll = (e) => {
      
      const scrollList = document.getElementById('scroll-list');
      
      /*
      console.log(
        "Target:", e.target,
        "Inside list:", imageList?.contains(e.target),
        "List open:", isImageListOpen
      );
      */
      // Allow scrolling inside the image list
      if (scrollList && scrollList.contains(e.target)) 
      {
          return;
      }
      
        e.preventDefault();
    };

    
    window.addEventListener('wheel', preventScroll, { passive: false });

    return () => {
        window.removeEventListener('wheel', preventScroll);
    };


  },[isAiEditOpen]);
  
  

  useEffect(() => {
    // redraw when localKey changes
    // console.log("value of operation", operation)
    // setOperation('select');
    // operationRef.current = 'select';
    // console.log("value of operationRef.current", operationRef.current)
    canvasRef.current.redraw();
  }, [refreshToggle]);

  useEffect(()=>{
    // console.log('operation changed TO:', operation);
    operationRef.current = operation;

     // Find the operation in iconMap
    const op = Object.values(iconMap)
      .flat()
      .find(item => item.key === operation);

    // Only change the cursor for URL-based operations
    if (op?.type === 'url') {
      document.body.style.cursor =
        `url('${op.icon}') ${op.hotX} ${op.hotY}, auto`;
    } else {
      document.body.style.cursor = '';
    }
    setRefreshToggle(prev => !prev);

  },[operation])

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      setContextMenu(null);
      onClipBoardRef.current = false;
    }
    
    if(e.key === 'Alt')
    {
      altKeyUp.current = false;
      return;
    }
    if(e.key === 'Delete')      
    {

      if(segmentOpRef.current==='lineop')
      {
        if(pASegmentRef.current !== null)
        {
          canvasRef.current.setSegmentAction('deleteSegment');          
          canvasRef.current.redraw();

        }
        else
        {
          let sameLine = isSameLine(pSegmentsRef.current);
          if(sameLine)
          {
            canvasRef.current.setSegmentAction('deleteLine');
          }
          canvasRef.current.redraw();   
          
        }
      }

      if (selectedRectRef.current.length > 0 && canvasRef.current && pauseDeleteRef.current === false) {
        canvasRef.current.deleteSelectedRect();
        setSelectedRect([]);
        selectedRectRef.current = [];

        setRectData({});
        setOperation('select');
        canvasRef.current.redraw();   
      }      
    }

    if ((e.ctrlKey || e.metaKey) && e.key === 'c' && pauseDeleteRef.current === false) 
    {
      if(segmentOpRef.current==='lineop')
      {
        canvasRef.current.setSegmentAction('copyLine');
        canvasRef.current.redraw();   
      }

      if (selectedRectRef.current.length > 0)
      {
        canvasRef.current.duplicateRect();
        e.preventDefault();  // Optionally prevent default browser action
      }
      

    }

     // Check if the key combination Ctrl (or Meta on Mac) + Z is pressed
    if ((e.ctrlKey || e.metaKey) && e.key === 'z' && pauseDeleteRef.current === false) {

      //undo operation

      /*
      if(operationRef.current === 'bezier')
      {
        canvasRef.current.undoBezier();
      }    
      if(operationRef.current === 'pline')
      {
        canvasRef.current.undoPline();
      }    
      if(operationRef.current === 'freehand')
      {
        canvasRef.current.undoFreeHand();
      }
  
      canvasRef.current.undo();
      */

      const undoActions = 
      {
        bezier: () => canvasRef.current.undoBezier(),
        pline: () => canvasRef.current.undoPline(),
        freehand: () => canvasRef.current.undoFreeHand(),
        default: () => canvasRef.current.undo()
      };
    
    (undoActions[operationRef.current] || undoActions.default)();

      // Your undo logic here
      e.preventDefault();  // Optionally prevent default browser action
    }
    

    // console.log("KeyDown");
    // console.log("operation:",operationRef.current);
    // console.log("Key: ", e.key);
    if ((operationRef.current === 'pline' && e.code === 'Space') || 
         (operationRef.current === 'freehand' && e.code === 'Space') ||
         (operationRef.current === 'bezier' && e.code === 'Space')) 
    {
      e.preventDefault(); // stops button from being "clicked"
      console.log("Setting select");
      setOperation('select');
      if(operationRef.current === 'freehand' || operationRef.current === 'pline')
      {
        canvasRef.current.finalizePolyline();      
      }

      if(operationRef.current === 'bezier')
      {
        canvasRef.current.finalizeBezier();      
        console.log("Finalize the bezier curve");
      }

      operationRef.current = 'select'
      
      setRefreshToggle(prev => !prev);
      
    }

    if (e.key === 'Escape') {

      console.log("Escape Presseed");
      if(animateOpRef.current != 'none')
      {
        console.log("Should be setting cursor to select");
        animateOpRef.current = 'none';
        canvasRef.current.setCursor('pointer');
        setIsAnimateDialogOpen(true);
        canvasRef.current.redraw();        

      }

      if(segmentOpRef.current==='lineop')
      {        
        canvasRef.current.escapeLineOp();
      }
      else
      {
        if(operationRef.current === 'pline')
        {       
          canvasRef.current.newPolyline();      
        }
      }

      canvasRef.current.resizeView(false);
    }

    if(operationRef.current === 'adjimage' && e.key ==='Escape')
    {
      operationRef.current = 'select';
      setOperation('select');
      setRefreshToggle(prev => !prev);
    }

    if (operationRef.current === 'bezier' && e.key === 'Escape') {
      canvasRef.current.newPolyline();      
    }

    if((operationRef.current === 'bezier' || operationRef.current === 'pline' ) && (e.key === 'Tab' || e.key === 'ArrowRight' || e.key === 'ArrowLeft'))
    {
      // Your undo logic here
      console.log("In a tab select");
      e.preventDefault();  // Optionally prevent default browser action
      canvasRef.current.tabPressed(e.shiftKey, e.key);
    }

    if(operationRef.current !== 'bezier' && operationRef.current !== 'pline' && (e.key === 'Tab' || e.key === 'ArrowRight' || e.key === 'ArrowLeft'))
    {
      if(!isAiPromptOpenRef.current && 
          !isHtmlEditorOpenRef.current &&
          !isLinkModalOpenRef.current &&
          !isAiEditOpenRef.current &&
          !isCopyModalOpenRef.current)
      {
          e.preventDefault();
      

        if(e.code != 'Space')
        {
          console.log("Do select Tab");
          canvasRef.current.rectTabPressed(e.shiftKey, e.key)
        }
        else
        {
          // console.log('Space Pressed');
        }
      }
    }
  };


  const saveDraft = () =>
  {
    pagesRef.current.pagesForDevice = pagesForDeviceRef.current;        
    // pagesRef.current.navigation.method = method;
    // pagesRef.current.navigation = navigationRef.current;
    let jsonFile = JSON.stringify(pagesRef.current);

    let lastSaved = localStorage.getItem('ait_local');
    let filename=localStorage.getItem('ait_filename');
    let fWithExt = `${filename}.ait`

    if(lastSaved !== jsonFile)
    {
        localStorage.setItem("draft_name",fWithExt);
        localStorage.setItem("draft", jsonFile);
    }
  }

  useEffect(() => {


    const resourceWrapper = async () => 
    {
      await getResources();
    }

    if(demo === false)
    {
      resourceWrapper();
    }
    else
    {
      resourceWrapper();
      // setFileList(["demo.ait"]);
    }
    
    let filename=localStorage.getItem('ait_filename');

    let fName = `${filename}.ait`;
    let exists = fileList.includes(fName);

    
    if(demo === true)
    {
      /*
      if(filename == undefined || filename == "")
      {
          setFilename("");

          if(demo === true)
          {
            createNewTemplate("demo");
          }
      }
      */
      console.log("in mount CreateTemplate");
      if(filename !== "" && filename !== ".ait")
      {
        setFilename(`free`);
        
        let aitName = `free.ait`;
        if(exists)              
        {
          handleOpenFile(aitName);
        }
      }

    }
    else
    {
      if(filename !== "" && filename !== ".ait")
      {
        setFilename(filename);
        
        let aitName = `${filename}.ait`;
        if(exists)
        {
          handleOpenFile(aitName);
        }
      }
    }



    const messageWrapper = async (original, draft) =>
    {
      const result = await Swal.fire({
        title: "Restore Draft?",
        text: "A newer draft was found locally.",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Restore",
        cancelButtonText: "Ignore"
      });
      
      if (result.isConfirmed) 
      {
        loadFromLocal(filename, draft);
      }
      else
      {
        loadFromLocal(filename, original);
      }

      localStorage.setItem("draft","");

    }

    if(!exists && filename !== "" && filename !== ".ait" )
    {
      let aitString = localStorage.getItem("ait_local");
      let draftString = localStorage.getItem("draft");

      if(draftString === "")
      {
        loadFromLocal(filename, aitString);
      }
      else
      {
        if(aitString !== draftString)
        {
          messageWrapper(aitString,draftString);
        }
            
      }
    }

    const handleKeyUp = (e) =>
    {
      
      if(e.key === 'Alt')
      {        
        altKeyUp.current = true;        
      }
  
    }
    console.log("mounted");

    restoreClipBoard(auth?.user?.webId, demo, () =>
        {            
          canvasRef.current.redraw();
          
        });

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);
    window.addEventListener('beforeunload', saveDraft);
    window.addEventListener('pagehide', saveDraft);


    return () => {    
        let jsonFile = JSON.stringify(pagesRef.current);
        localStorage.setItem("ait_local",jsonFile);

        window.removeEventListener('keydown', handleKeyDown);
        window.removeEventListener('keyup',handleKeyUp);
        window.removeEventListener('beforeunload', saveDraft);
        window.addEventListener('pagehide', saveDraft);
        }
   
  },[]);


  const fetchWithAuth = async (url, options = {}) => {
    const response = await fetch(url, {
      ...options,
      credentials:  demo===true ? "omit" : "include",  // Send cookies/session
    });
  
    if (response.status === 401 || response.status === 403) {
      console.warn("JWT invalid or expired. Logging out...");
      onLogout(); // <-- your logout function
      throw new Error("Unauthorized");
    }
  
    return response;
  };


  const getResources = async () => {
    setIsWaitingForFiles(true);
    let command = Util.serverName + "/protected/getTemplateList";
    
    if(demo === true)
    {
      command = Util.serverName + "/api/getTemplateList";
    }
    try {
      const response = await fetchWithAuth(command, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({}),
      });

      const data = await response.json();

      if (!response.ok) {
        setIsWaitingForFiles(false);
        return;
      }

      if (!data.status) {
        setIsWaitingForFiles(false);
        return;
      }

      let u = Util.getInstance();
      let fileArray = data.files;
      let aitA = [];
      fileArray.forEach((ait) => {
        if(u.isAitFile(ait))
        {
            aitA.push(ait);
        }
      });

      console.log("Getting resources");
      console.log(JSON.stringify(aitA));
      setFileList(aitA);
      setIsWaitingForFiles(false);
    } 
    catch (error) 
    {
      console.log("Error thrown:");
    }
  };

  const getImageResources = async () => {
    setIsWaitingForFiles(true);
    let command = Util.serverName + "/protected/getUserDirList";
    if(demo === true)
    {
      command = Util.serverName + "/api/getUserDirList";
    }
    
    try {
      const response = await fetchWithAuth(command, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({}),
      });

      const data = await response.json();

      if (!response.ok) {
        setIsWaitingForFiles(false);
        return;
      }

      if (!data.status) {
        setIsWaitingForFiles(false);
        return;
      }

      let u = Util.getInstance();
      let fileArray = data.files;
      let imgA = [];
      fileArray.forEach((img) => {
        if(u.getImageTypeFromFilename(img) != 'Unknown')
        {
            imgA.push(img);
        }
      });

      setFileList(imgA);
      setIsWaitingForFiles(false);
    } 
    catch (error) 
    {
      console.log("Error thrown:", error);
    }
  };

  

  const handleOperationChange = (op) => {    
    if (op === 'open' ) {
      let isDisabled = !canSaveRef.current && !dataChanged;
      if (!isDisabled) {
        Swal.fire({
          title: 'Save?',
          text: 'Save changes before opening another file?',
          icon: 'warning',
          showCancelButton: true,
          showDenyButton: true,
          confirmButtonText: 'Save',
          denyButtonText: "Don't Save",
          cancelButtonText: 'Cancel'
        }).then((result) => {
          if (result.isConfirmed) {
            // Save first, then open
            handleSave();
            openModal();
          } else if (result.isDenied) {
            // Open without saving
            openModal();
          }
          // Cancel: do nothing
        });
      } else {
         openModal();
      }
    
      return;
    }
    /*
    if (op === 'open') {
      openModal();
      return;
    }
    */
    if(op=== 'menubar')
    {
      // find first menubar rect (if any)
      const menuBarRect = pagesRef.current?.pages
      ?.flatMap(page => page.layout)
      ?.find(rect => rect.type === 'Menubar');

      if (menuBarRect) 
      {
        Swal.fire({
          title: 'Error',
          text: "Only One Menubar allowed in a page for layout purposes",
          icon: 'error',
          confirmButtonText: 'OK',
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,    
        });                      
        return;
       }
    }

    if (op === 'new')
    {

      const openNew = () =>
      {
        if(demo === true)
        {
          createNewTemplateDialogDemo();
        }
        else
        {
          createNewTemplateDialog();
        }
      }

      let isDisabled = !canSaveRef.current && !dataChanged;
      if (!isDisabled) {
        Swal.fire({
          title: 'Save?',
          text: 'Save changes before opening another file?',
          icon: 'warning',
          showCancelButton: true,
          showDenyButton: true,
          confirmButtonText: 'Save',
          denyButtonText: "Don't Save",
          cancelButtonText: 'Cancel'
        }).then((result) => {
          if (result.isConfirmed) {
            // Save first, then open
            handleSave();
            openNew();
          } else if (result.isDenied) {
            // Open without saving
            openNew();
          }
          // Cancel: do nothing
        });
      } else {
          openNew();
        // openModal();
      }

      return;
    }

    if(op === 'export')
    {
      console.log("Exporting layout");
      exportLayout();
      return;
    }

    if(op === 'import')
    {
      console.log("Importing Layout");
      importLayout();
      return;
    }

    
    if (op === 'delete') 
    {
      if (selectedRect.length > 0 && canvasRef.current) {
        canvasRef.current.deleteSelectedRect();
        setSelectedRect([]);
        selectedRectRef.current = [];

        setRectData({});
        setOperation('select');
      }
      return;
    } 
    if (op === 'undo') 
    {
      canvasRef.current.undo();
      return;
    } 

    if (op === 'redo') 
    {
      canvasRef.current.redo();
      return;
    }

    if(op === 'clear')
    {
      canvasRef.current.clear();
      return;
    }

    if(op === 'preview')
    {
      handlePreview();      
    }
    if(op === 'previewCode')
    {
      handlePreviewCode();
    }

    if(op === 'save')
    {
      handleSave();
      return;
    }
    

    if(op === 'svgtext')
    {
      // handleSvgTextOptions()
      // setOperation("select")
      // return;
    }
    
    if(op === 'bezier' || op === 'pline')
    {
      console.log("Resetting line history");
      canvasRef.current.resetLineHistory();
    }
    console.log("op: ", op);
    setOperation(op);
    setActiveHelpKey(op);  // Immediately set the helpKey when entering
  };

  const handleCoordUpdate = (x, y) => {

    let xFixed=x.toFixed(2);
    let yFixed = y.toFixed(2);
    setCoords({ x:xFixed, y:yFixed });
  };

  const handlePreview = () => {

    pagesRef.current.pagesForDevice = pagesForDeviceRef.current;      

    // console.log(pagesRef.current.pages);

    canvasRef.current.regenIds(pagesRef.current.pages);

    
    let htmlContent = toHtml(pagesRef.current,"demo", demo, true);

    if(demo === false)
    {  
        let webId  =  auth?.user?.webId;
        let userStr = `${webId}`;
        htmlContent = toHtml(pagesRef.current, userStr, demo, true);  
    }
  
    const blob = new Blob([htmlContent], { type: "text/html" });
    const url = URL.createObjectURL(blob);
    
    const w = window.open(url, "_blank");
    if (w) w.focus();

    /*
    sessionStorage.setItem("preview-html", htmlContent);    
    const previewWindow = window.open("/preview.html", "_blank");
    if (previewWindow) {
      const previewContent = sessionStorage.getItem("preview-html");

      if (previewContent) {
        document.open();
        document.write(previewContent);
        document.close();
      }
      // previewWindow.document.open();
      // console.log(htmlContent);
      // previewWindow.document.write(htmlContent);
      // previewWindow.document.close();
    }
    */
  }


  const handlePreviewCode = () => {
    // Assuming `pagesForDeviceRef` and `pagesRef.current` are correctly initialized
    pagesRef.current.pagesForDevice = pagesForDeviceRef.current;      
    canvasRef.current.regenIds(pagesRef.current.pages);
  
    // Convert to HTML (assuming `toHtml` is a function that generates the HTML content)
    
    let htmlContent = toHtml(pagesRef.current, "demo", demo, true);

    if(demo === false)
    {

      let webId  =  auth?.user?.webId;
      let userStr = `${webId}`;
      htmlContent = toHtml(pagesRef.current, userStr, demo, true);
    }
  
    // Open a new window for preview
    const previewWindow = window.open("", "_blank");
    
    if (previewWindow) {
      // Write the HTML structure to the preview window
      previewWindow.document.open();
      
      // Create a simple HTML structure with a read-only textarea to display the HTML content
      previewWindow.document.write(`
        <html>
          <head>
            <title>HTML Preview</title>
            <style>
              /* Make sure the body and html take up full height and margin is removed */
              html, body {
                height: 100%;
                margin: 0;
                padding: 0;
                overflow: hidden;
              }
              textarea {
                width: 100%;
                height: 100%;
                padding: 10px;
                font-family: "Courier New", monospace;
                font-size: 14px;
                line-height: 1.5;
                border: none;
                background-color: #f4f4f4;
                color: #333;
                white-space: pre-wrap;
                word-wrap: break-word;
                overflow-wrap: break-word;
                resize: none;
                box-sizing: border-box;
              }
            </style>
          </head>
          <body>
            <textarea readonly>${htmlContent}</textarea>
          </body>
        </html>
      `);
  
      // Close the document to apply the changes
      previewWindow.document.close();
    }
  };



  const handleAnimateSelect = (rect) =>
  {     
    if(rect === null)
    {
      setIsAnimateDialogOpen(true);
      animateOpRef.current = 'none';
      canvasRef.current.setCursor('pointer');
      canvasRef.current.resizeView(false);
      return;

    }
    if(rect.type==='Bezier' || 
      rect.type === 'Prect' || 
      rect.type === 'SvgText' || 
      rect.type === 'SvgEmoji' ||
      rect.subType === 'SvgRect' || 
      rect.subType === 'SvgSquare' ||
      rect.subType === 'SvgCircle' ||
      rect.subType === 'SvgEllipse')
    {
      setIsAnimateDialogOpen(true);
      animateOpRef.current = 'none';
      canvasRef.current.setCursor('pointer');
      canvasRef.current.resizeView(false);
    }
  }

  const handleRectSelect = (rect, e, onClip, segments, aSegment,lines) => {
    // Clear context menu by default

     // Only clear if not a right-click
    if (!e || e.button !== 2) {
      setContextMenu(null);
      onClipBoardRef.current = false;
      pSegmentsRef.current= [];
    }
  
    // console.log('OnClip: ', onClip);
    // If nothing is selected
    if (Array.isArray(rect) && rect.length === 0 && onClip === false && segments.length === 0) {
      setSelectedRect([]);
      selectedRectRef.current = [];

      //select context menu for page
      if (e && e.button === 2) 
      {
        if(operationRef.current != 'adjimage' &&
          segmentOpRef.current !=='lineop' &&
          animateOpRef.current !== 'selectMPath' &&
          animateOpRef.current !== 'selectMObj' &&
          animateOpRef.current !== 'handleOffset' &&
          animateOpRef.current !== 'handleOffsetPath' &&
          animateOpRef.current !== 'resizeView'
        )
        {
          setContextMenu({ x: e.clientX, y: e.clientY });
        }
      }
      else
      {
        setContextMenu(null);
      }
      return;
    }
  
    if(onClip === false)
    {
      // Store rect selection (can be single or multiple)
      setSelectedRect(rect);
      selectedRectRef.current = rect;

      if(rect.length===1)
      {
        if(rect[0].type==="Menubar")
        {
            setMethodExt("menu");
            navigationRef.current.method="menu";
            navigationRef.current.menubar.visible = true;
            navigationRef.current.menubar.rectId = rect[0].id;
        }
      }
    
      // If it's a single rect, update metadata
      const firstRect = Array.isArray(rect) ? rect[0] : rect;
    
      setRectData(firstRect);
    }
  
    // Show context menu on right-click
    if (e && e.button === 2) {

      pSegmentsRef.current=segments;
      pASegmentRef.current=aSegment;
      pLinesRef.current=lines;

      e.preventDefault(); // prevent system context menu
      e.stopPropagation();

      if(contextMenu == null)
      {
        setContextMenu({ x: e.clientX, y: e.clientY });
      }
      else
      {
        setContextMenu(null);
      }

      console.log("clientX: ", e.clientX);
      console.log("clientY: ", e.clientY);
      if(onClip === true)
      {        
        console.log("Help with the magic");
        onClipBoardRef.current = true;        
      }
    }

    console.log("Rectangle selected");
    if(selectedRectRef.current.length === 1)
    {

        let r = selectedRectRef.current[0];
        
        console.log("type: ", r.type);
        console.log("subtype: ", r.subType);

        if(r.type === "Rectangle")
        {
          let key = `${r.type}${r.subType}`;
          console.log("Active Key: ", key);
          setActiveHelpKey(key);
        }
        else
        {
          if(r.type=== 'Bezier' || r.type === 'Prect')
          {
            let r = selectedRectRef.current[0];
            let p = r.path;
            let multi = "";
            if(p.length > 1)
            {
              multi = "_multi";
            }


            let key = r.type+multi;
            setActiveHelpKey(key);
          }
          else
          {
            setActiveHelpKey(r.type);
          }
        }
    }
    else
    {
      if(selectedRectRef.current.length > 1)
      {
        setActiveHelpKey("multi");
      }
      else
      {
        if(onClip === false)
        {
          setActiveHelpKey("none");
        }
      }
    }

    if (onClip === true)
    {
      setActiveHelpKey("clip");
    }    
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'filename') {
      const cleaned = value.replace(/\.[^/.]+$/, '');
      setFilename(cleaned);
    } else {
      setDataChanged(true);
      setRectData((prev) => ({ ...prev, [name]: value }));
      if (selectedRect[0]) selectedRect[0][name] = name === 'zIndex' ? parseInt(value) : value;
    }
  };

  const exportLayout = () => {

    console.log("datachanged: ", dataChanged);
    console.log("canSave: ", canSaveRef.current);
    
    pagesRef.current.pagesForDevice = pagesForDeviceRef.current;        
    // pagesRef.current.navigation.method = method;
    // pagesRef.current.navigation = navigationRef.current;

    let jsonFile = JSON.stringify(pagesRef.current, null, 2);

    // for saving in a local directory
    const blob = new Blob([jsonFile], { type: 'application/json' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = `${filename}.ait`;
          link.click();
          URL.revokeObjectURL(link.href);
    


  }

  const loadFromLocal=(fileName, aitString) =>
  {
          try {

            // const text = await file.text();
            const text = aitString;

            if(text == null)
            {          
              throw new Error("Error reading AIT File");
            }
            const data = JSON.parse(text);

            
            if (!Array.isArray(data.pages)) {
              throw new Error('Invalid AIT format.');
            }
            

            let nameWithoutExtension = fileName.replace(/\.ait$/, "");
            
            if(demo === true)
            {
              nameWithoutExtension = "free";
            }

            setFilename(nameWithoutExtension);

            pagesRef.current = data;

            setCurrentPage(1);
            setTotalPages(pagesRef.current.pages.length);
            setPageWidth(pagesRef.current.pages[0].pageWidth);
            setPageHeight(pagesRef.current.pages[0].pageHeight);
            setPageId(pagesRef.current.pages[0].pageId);
            setDeviceId(pagesRef.current.pages[0].deviceId);
            setMethodExt(pagesRef.current.navigation.method);

            // console.log("pageInfo: ", pagesRef.current.pages[0].pageInfo.name);

            pagesForDeviceRef.current = pagesRef.current.pagesForDevice;
            navigationRef.current = pagesRef.current.navigation;
            
            // console.log(JSON.stringify(pagesForDeviceRef.current));

            devicesRef.current = pagesRef.current.devices;      

            localStorage.setItem('ait_filename',nameWithoutExtension);
            localStorage.setItem('ait_local',text);

            if (canvasRef.current) 
            {
              canvasRef.current.setRectangles(pagesRef.current.pages[0].layout);
              canvasRef.current.setPageInfo(pagesRef.current.pages[0].pageInfo);
              canvasRef.current.redraw();
            }

            setSelectedRect([]);
            selectedRectRef.current = [];

            setRectData({});
            setOperation('select');
            setIsModalOpen(false);
          } 
          catch (err) {
            setFilename('');
            localStorage.setItem('ait_filename','');
            localStorage.setItem('clipBoard','[]');
            localStorage.setItem('bezier','[]');
            localStorage.setItem('pline','[]');
            localStorage.setItem('controls','[]');
            alert('Failed to load AIT file: ' + err.message);
          }
    
  }
  const importLayout = () => {

    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".ait,application/json";
  
    input.onchange = async (event) => {
      const file = event.target.files[0];
      if (!file) return;

      const fileName = file.name; 
      const reader = new FileReader();
  
      reader.onload = (e) => {
        try {
          const text = e.target.result;

          loadFromLocal(fileName,text);
  
        } catch (err) {
          console.error("Failed to import layout:", err);
          alert("Invalid layout file");
        }
      };
  
      reader.readAsText(file);
    };
  
    // open file picker
    input.click();
  };


  const importSvg = async (rect) => {

    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".svg,image/svg+xml";
  
    input.onchange = async (event) => {
      const file = event.target.files[0];
      if (!file) return;
  
      const reader = new FileReader();
  
      reader.onload = async (e) => {
        try {
          const svgText = e.target.result;
  
          console.log("fileName:", file.name);
  
          await canvasRef.current.updateBezier(rect, svgText, true);
  
        } catch (err) {
          console.error("Failed to import SVG file:", err);
          alert("Invalid SVG file");
        }
      };
  
      reader.readAsText(file);
    };
  
    input.click();
  };


  
  const handleSave = async () => {

    const rectangles = canvasRef.current?.getRectangles() || [];

    const saveFile = async (fn) =>
    {
        // const command = Util.serverName + "/protected/saveAit";
        const command = Util.serverName + "/protected/uploadT";
        
        pagesRef.current.pagesForDevice = pagesForDeviceRef.current;        
        // pagesRef.current.navigation.method = method;
        // pagesRef.current.navigation = navigationRef.current;

        console.log("Command: ", command);
        let aFile = JSON.stringify(pagesRef.current);        

        // jsonString = your file content
        // fileName = desired filename, e.g. "template.ait"
        
        let fileName = `${fn}.ait`;
        
        let formData = new FormData();

        // Convert string into a Blob/File
        let virtualFile = new File(
          [aFile],
          fileName,
          {
            type: "text/plain", // good for .ait or text templates
            lastModified: Date.now()
          }
        );

        // Append like normal uploaded file
        formData.append("htmlFile", virtualFile, virtualFile.name);


        try {

          Swal.fire({
            title: 'Please wait...',
            text: 'Processing your request',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });

          const response = await fetchWithAuth(command, {

            method: "POST",
            body: formData,
            credentials: "include"
          });
    
          const data = await response.json();
    
          if (!response.ok) {            
            Swal.fire({
                title: 'Error',
                text: "Bad Response",
                icon: 'error',
                confirmButtonText: 'OK',
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,    
              });                    
        
            return;
          }
              
          if (!data.status) 
          {            
            Swal.close();

            Swal.fire({
                title: 'Error',
                text: message,
                icon: 'error',
                confirmButtonText: 'OK',
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,    
              });                    

            return;
          }


          
          let htmlFileName = `${fn}.html`;

          pagesRef.current.pagesForDevice = pagesForDeviceRef.current;      
          canvasRef.current.regenIds(pagesRef.current.pages);
          let webId  =  auth?.user?.webId;
          let userStr = `${webId}`;
          let htmlFile = toHtml(pagesRef.current, userStr, demo, false);    

          let formData2 = new FormData();

          // Convert string into a Blob/File
          let virtualFile2 = new File(
            [htmlFile],
            htmlFileName,
            {
              type: "text/plain", // good for .ait or text templates
              lastModified: Date.now()
            }
          );
  
          // Append like normal uploaded file
          formData2.append("htmlFile", virtualFile2, virtualFile2.name);
  
  

          const response2 = await fetchWithAuth(command, {
  
              method: "POST",
              body: formData2,
              credentials: "include"
            });
      
          const data2 = await response2.json();
      
          if (!response2.ok) {            
              Swal.close();

              Swal.fire({
                  title: 'Error',
                  text: "Bad Response",
                  icon: 'error',
                  confirmButtonText: 'OK',
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  allowEnterKey: false,    
                });                    
          
              return;
          }
      
            
          if (!data2.status) 
          {   
              Swal.close();         
              Swal.fire({
                  title: 'Error',
                  text: message,
                  icon: 'error',
                  confirmButtonText: 'OK',
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  allowEnterKey: false,    
                });                    
  
             return;
           }
  
  
          let message = `Saved ${fileName} and ${htmlFileName}: ${data2.message}`
                   

          Swal.close();
          Swal.fire({
            title: 'Success',
            text: message,
            icon: 'success',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,    
          });     
          
          canvasRef.current.clearHistory();
          setDataChanged(false);
          
          localStorage.setItem('ait_filename',fn);
          localStorage.setItem('ait_local',aFile);            
        }
        catch(err)                 
        {
            Swal.fire({
                title: 'Exception',
                text: err?.message,
                icon: 'error',
                confirmButtonText: 'OK',
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,    
              });                    
        }
    }

    if(selectedFile =="" &&  (!filename.trim())) 
    {

        Swal.close();
        Swal.fire({
            title: 'Info',
            text:"File name must be specified",
            icon: 'info',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,    
          });                    

      return;
    }

    let fn = filename.trim();

    if(!fn)
    {
        fn = selectedFile;
    }

    if(demo === false)
    {
      await saveFile(fn);
      localStorage.setItem("draft", "");     
    }
    else
    {

      console.log("datachanged: ", dataChanged);
      console.log("canSave: ", canSaveRef.current);
      


      pagesRef.current.pagesForDevice = pagesForDeviceRef.current;        
      // pagesRef.current.navigation.method = method;
      // pagesRef.current.navigation = navigationRef.current;

      let jsonFile = JSON.stringify(pagesRef.current);

      canvasRef.current.clearHistory();
      setDataChanged(false);      
      canSaveRef.current = false;

      localStorage.setItem('ait_filename',fn);
      localStorage.setItem('ait_local',jsonFile);
      localStorage.setItem("draft", "");
      setRefreshToggle(prev => !prev);

    }

    /*

    // for saving in a local directory
    const blob = new Blob([JSON.stringify(jsonOutput, null, 2)], { type: 'application/json' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${filename}.ait`;
    link.click();
    URL.revokeObjectURL(link.href);
    */
  };


  const openModal = async () =>
  {
    console.log("opening model");

    if(demo === false)
    {
      await getResources();
    }
    setIsModalOpen(true)
  }

  const handleOpenImage =  (fileName) => {

    if(selectedRect.length === 1)
    {      
      if(selectedRect[0].type==='Prect' || selectedRect[0].subType === 'SvgCircle')      
      {
        selectedRect[0].imageName = fileName;
      }
      else
      {
        selectedRect[0].imageName = fileName;
        selectedRect[0].rotation=0;
      }
      canvasRef.current.redraw();

      setRectData(selectedRect[0]);
      setIsImageModalOpen(false);
    }
  }

  const handleOpenFile = async (fileName) => {

    setLoadingFile(fileName);
     const getAit = async () =>
     {
        /*
        if(demo===true)
        {
          let text=localStorage.getItem('ait_local');
          return text;
        }
        */       
        let command = Util.serverName + "/protected/getAit";
        if (demo === true)
        {
          command = Util.serverName + "/api/getAit";
        }

        const response = await fetchWithAuth(command, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({fileName:fileName}),
          });
    
          const data = await response.json();
    
          if (!response.ok) {          
            setLoadingFile(null);
            setFilename('');
            return null;
          }
    
          if (!data.status) {
            setLoadingFile(null);
            setFilename('');
            return null;
          }

          return data.data;
     };

      try {
        // const text = await file.text();

        let draft = localStorage.getItem("draft");
        
        let text="";
        let restore = false;

        let lastOpenFile = localStorage.getItem('draft_name');

       

        if(draft=== "")
        {          
          text = await getAit();
          
        }
        else
        {
          console.log("lastOpenFile: ",lastOpenFile);
          console.log('current: ', fileName);
          if(lastOpenFile === fileName)
          {
            const result = await Swal.fire({
              title: "Restore Draft?",
              text: "A newer draft was found locally.",
              icon: "question",
              showCancelButton: true,
              confirmButtonText: "Restore",
              cancelButtonText: "Ignore"
            });
            
            if (result.isConfirmed) 
            {
              if(draft === "" || draft === undefined)
              {
                console.log("Invalid page");
                text = await getAit();          
              }
              else
              {
                text = draft;   

              }
              restore = true;
              setDataChanged(true); 
            }  
            else
            {
              text = await getAit();             
            }
              
          }
          else
          {
            text = await getAit();           
          }
      
        }

        // const text = await getAit();
        if(text == null)
        {          
          setLoadingFile(null);
          throw new Error("Error reading AIT File");
        }
        let data = JSON.parse(text);

        
        if (!Array.isArray(data.pages)) 
        {
            setLoadingFile(null);
            throw new Error('Invalid AIT format.');
        }
        
        const nameWithoutExtension = fileName.replace(/\.ait$/, "");

        // setFilename(nameWithoutExtension);

        pagesRef.current = data;

        setCurrentPage(1);
        setTotalPages(pagesRef.current.pages.length);
        setPageWidth(pagesRef.current.pages[0].pageWidth);
        setPageHeight(pagesRef.current.pages[0].pageHeight);
        setPageId(pagesRef.current.pages[0].pageId);
        setDeviceId(pagesRef.current.pages[0].deviceId);
        setMethodExt(pagesRef.current.navigation.method);

        // console.log("pageInfo: ", pagesRef.current.pages[0].pageInfo.name);

        pagesForDeviceRef.current = pagesRef.current.pagesForDevice;
        navigationRef.current = pagesRef.current.navigation;
        
        // console.log(JSON.stringify(pagesForDeviceRef.current));

        devicesRef.current = pagesRef.current.devices;      

        if(demo === true)
        {
          localStorage.setItem('ait_filename','free');
          localStorage.setItem("draft_name",'free');
          setFilename("free");
        }
        else
        {
          localStorage.setItem('ait_filename',nameWithoutExtension);
          setFilename(nameWithoutExtension);
          localStorage.setItem("draft_name",fileName);
        }
        localStorage.setItem('ait_local',text);

        if(restore !== true)
        {
          localStorage.setItem("draft","");
        }
       

        if (canvasRef.current) 
        {
          canvasRef.current.setRectangles(pagesRef.current.pages[0].layout);
          canvasRef.current.setPageInfo(pagesRef.current.pages[0].pageInfo);
          canvasRef.current.redraw();
          canvasRef.current.clearHistory();
        }

        setSelectedRect([]);
        selectedRectRef.current = [];

        setRectData({});
        setOperation('select');
        setLoadingFile(null);
        setIsModalOpen(false);
        setDataChanged(false);      
        canSaveRef.current = false;
  
      } catch (err) {
        setLoadingFile(null);
        setFilename('');
        if(demo === true)
        {
          localStorage.setItem('ait_filename','free');
        }
        else
        {
          localStorage.setItem('ait_filename','');
        }
        localStorage.setItem('clipBoard','[]');
        localStorage.setItem('bezier','[]');
        localStorage.setItem('pline','[]');
        localStorage.setItem('controls','[]');
        localStorage.setItem('draft','');
        localStorage.setItem('draft_name','');
        canvasRef.current.clear();
        alert('Failed to load AIT file: ' + err.message);
      }
  };


  function setDeviceInfo(pageId, deviceId) {
    const deviceIndex = devicesRef.current.findIndex(device => deviceId === device.name);
    const [prefix, number] = pageId.split("_");
  
    devicesRef.current.forEach((device, index) => {
      if (index >= deviceIndex) {
        const arr = pagesForDeviceRef.current[device.name];
  
        // Check if prefix exists
        const existingIndex = arr.findIndex(page => page.id.startsWith(prefix + "_"));
        // Use `match` to extract the number after the underscore and convert it to an integer
        const pageAtSpot = arr.find(page => page.id.startsWith(prefix + "_"))

        // console.log("Id at spot: ", pageAtSpot);

        const newPageObj = { id: pageId, name: prefix };
  
        if (existingIndex >= 0) {
          // Replace the page while keeping its position
          console.log("Replacing: ", device.name);

          const [p, n] = pageAtSpot.id.split("_");
          if(index == deviceIndex)          
          {
            arr[existingIndex] = newPageObj;
          }
          else
          {
            console.log("Testing whether to replace");
            console.log("device: ", deviceIndex);
            console.log("at Spot: ", n)
            if(deviceIndex >= n)
            {
              arr[existingIndex] = newPageObj;
            }
            else
            {
              console.log("No replacement");
            }
          }
        } else {
          // Insert at the same index as in the original pages array, if possible
          // Default to end if not known
          arr.push(newPageObj);
        }
      }
    });
  }


  const createNewTemplate = (templateName) =>
  {

    console.log("Creating demo template:", templateName);
    setCurrentPage(1);
    setTotalPages(1);

    let id = getUnique(unique);
    let pageId = `${id}_0`;
    let deviceId = devicesRef.current[0].name;

    setDeviceInfo(pageId, deviceId);
    setPageId(pageId);
    setDeviceId(deviceId);
    setUnique(id);

    let p = [];
    let pageInfo = {
      name: `${id}`,
      pageTheme: "",
      browserBackground:"#dddddd",
      pageBackground:"#ffffff",
      fillMode:"solid",
      gradientColor1: "#ffffff",
      gradientColor2: "#000000",
      gradientAngle:  0,                
      marginTop: 10,
      marginBottom:10  
    };

    p.push({
      pageWidth: pageWidth,
      pageHeight: pageHeight,
      pageId: pageId,
      deviceId: deviceId,
      pageInfo: pageInfo,
      layout: []
    });

    // setPageWidthExt(devicesRef.current[0].maxWidth);
    setPageWidthExt(432);
    setPageHeight(932);

    let pageObj = {
      navigation: navigationRef.current,
      devices: devicesRef.current,
      pagesForDevice: pagesForDeviceRef.current,
      pages: p
    };

    pagesRef.current = pageObj;
    canvasRef.current.setPageInfo(pageObj.pageInfo);    
    setFilename(templateName);

    // console.log(JSON.stringify(pagesRef.current));

    canvasRef.current.clear();
    canvasRef.current.clearHistory();
    setDataChanged(false);      

    localStorage.setItem('ait_filename',templateName);
    localStorage.setItem('draft_name',templateName);
    let text = JSON.stringify(pageObj);
    localStorage.setItem('ait_local',text);
    localStorage.setItem('draft','');
    

    
  }

  const createNewTemplateDialogDemo = async () => {
    // Inform the user about demo mode restrictions
    await Swal.fire({
      title: 'Free Mode',
      html: `
        <p>You are currently using the <strong>Free Version</strong> of AIT Editor.</p>
        <p>The creation of new templates is not allowed in free mode.</p>
        <p>Upgrade to the full version to create and manage multiple templates with ease.</p>
      `,
      icon: 'info',
      confirmButtonText: 'Continue'
    });
    
    const templateName = 'demo';
  
    try {
      /*
      const doesTemplateExist = (template, file) => {
        const filename = `${template}.ait`;
        return file.includes(filename);
      };
  
      let exists = doesTemplateExist(templateName, fileList);
      if (exists) {
        Swal.fire(
          'Notice',
          'The demo template already exists. In the free version, only one template can be created.',
          'warning'
        );
        return true;
      }
  
      createNewTemplate(templateName);
      */
      /*
      console.log("Creating demo template:", templateName);
      setCurrentPage(1);
      setTotalPages(1);
  
      let id = getUnique(unique);
      let pageId = `${id}_0`;
      let deviceId = devicesRef.current[0].name;
  
      setDeviceInfo(pageId, deviceId);
      setPageId(pageId);
      setDeviceId(deviceId);
      setUnique(id);
  
      let p = [];
      let pageInfo = {
        name: `${id}`,
        pageTheme: ""
      };
  
      p.push({
        pageWidth: pageWidth,
        pageHeight: pageHeight,
        pageId: pageId,
        deviceId: deviceId,
        pageInfo: pageInfo,
        layout: []
      });
  
      setPageWidthExt(devicesRef.current[0].maxWidth);
      setPageHeight(768);
  
      let pageObj = {
        navigation: navigationRef.current,
        devices: devicesRef.current,
        pagesForDevice: pagesForDeviceRef.current,
        pages: p
      };
  
      pagesRef.current = pageObj;
      setFilename(templateName);
      canvasRef.current.clear();
      canvasRef.current.clearHistory();
      setDataChanged(false);      
      */
  
      // Swal.fire('Success', 'Demo template created!', 'success');
    } catch (error) {
      let msg = error.msg || 'An unexpected error occurred.';
      Swal.fire('Error', msg, 'error');
    }
  };
  


  
  const createNewTemplateDialog = async () => {
    const { value: templateName } = await Swal.fire({
      title: 'Create New Template',
      input: 'text',
      inputLabel: 'Enter a name for your new template',
      inputPlaceholder: 'e.g. homepage-layout',
      inputAttributes: {
        maxlength: 50,
        autocapitalize: 'off',
        autocorrect: 'off'
      },
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return 'Template name is required.';
        }
        if (value.includes('.')) {
          return 'Do not include a file extension (e.g., .ait).';
        }
        return null;
      }
    });
  
    if (templateName) {
      try {

        const doesTemplateExist = (template, file) => {
          const filename = `${template}.ait`;
          return file.includes(filename);
        };

        let exists = doesTemplateExist(templateName,fileList);
        if(exists)
        {
          Swal.fire('Error', 'Template name already exists, Please try again', 'error');
          return true;
        }
        
        createNewTemplate(templateName);
        /*
        console.log("Creating new template:", templateName);
        setCurrentPage(1);
        setTotalPages(1);
        
        console.log("unique");
        let id = getUnique(unique);

        let pageId = `${id}_0`;
        let deviceId = devicesRef.current[0].name;

        setDeviceInfo(pageId, deviceId);

        setPageId(pageId);
        setDeviceId(deviceId);
        setUnique(id);

        let p = [];
        
        let pageInfo = {name: `${id}`,                    
                        pageTheme: ""};
                  

        p.push({pageWidth:pageWidth, pageHeight:pageHeight, pageId:pageId, deviceId:deviceId, pageInfo:pageInfo, layout:[]});

        setPageWidthExt(devicesRef.current[0].maxWidth);
        setPageHeight(768);

                        
        let pageObj = {navigation: navigationRef.current, devices: devicesRef.current, pagesForDevice: pagesForDeviceRef.current, pages:p};
        pagesRef.current = pageObj;
        
        setFilename(templateName);
        canvasRef.current.clear();
        canvasRef.current.clearHistory();
        setDataChanged(false);
        
        */

        // Optionally show a success dialog:
        // Swal.fire('Success', 'Template created!', 'success');
      } catch (error) {

        let msg = error.msg;
        Swal.fire('Error', msg, 'error');
      }
    }
  };
  
  function rotate()
  {
        Swal.fire({
          title: 'Rotate Image',
          input: 'number',
          inputLabel: 'Enter rotation (degrees)',
          inputPlaceholder: 'e.g. 30',

          inputValue: selectedRect.length === 1 
          ? selectedRect[0].rotation || 0 
          : 0,             
          inputAttributes: {
            min: -360,
            max: 360,
            step: 1
          },
          showCancelButton: true,
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',

          didOpen: () => {
            const input = Swal.getInput();
            if (input) {
              input.select(); // 👈 this selects the whole value
            }
          },

          inputValidator: (value) => {
            if (!value && value !== "0") {
              return 'Please enter a number'
            }
          }
        }).then((result) => {
          if (result.isConfirmed) {
            let angle = parseFloat(result.value);
            if (!isNaN(angle)) {
              if(selectedRect.length === 1)
              {
                  // selectedRect[0].rotation = angle;
                  canvasRef.current.rotate(angle, selectedRect[0]);
              }
              console.log("Angle entered: ", angle);
      
            }
          }
        });
  }
  
  const handleContextMenuAction = (action) => {
    if(pSegmentsRef.current.length !== 0)
    {
      switch (action)
      {
          case 'moveAll':                        
            canvasRef.current.setSegmentAction('moveAll');
            break;
          case 'moveSelected':
            canvasRef.current.setSegmentAction('moveSelected')
            break;
          case 'deleteSelected':
              canvasRef.current.setSegmentAction('deleteSelected')
              break;  
          case 'copySelected':
              canvasRef.current.setSegmentAction('copySelected')
              break;    
          case 'moveLine':
            canvasRef.current.setSegmentAction('moveLine');
            break;  
          case 'lineToFront':
            canvasRef.current.setSegmentAction('lineToFront');
            break;    
          case 'lineToBack':
            canvasRef.current.setSegmentAction('lineToBack');
            break;    
          case 'copyLine':
              canvasRef.current.setSegmentAction('copyLine');
              break;  
          case 'deleteLine':
                canvasRef.current.setSegmentAction('deleteLine');
                break;    
          case 'joinLine':
                canvasRef.current.setSegmentAction('joinLine');
                break;      
          case 'mirrorLine':
                  canvasRef.current.setSegmentAction('mirrorLine');
                  break;      
          case 'rotateLine':
                  canvasRef.current.setSegmentAction('rotateLine');
                  break;          
          case 'resizeLine':
                    canvasRef.current.setSegmentAction('resizeLine');
                    break;            
          case 'settings':
            openSettingDialog();            
            break;                            
          case 'moveSegment':
              canvasRef.current.setSegmentAction('moveSegment');
              break;    
          case 'breakSegment':
              canvasRef.current.setSegmentAction('breakSegment');
              break;   
          case 'deleteSegment':
              canvasRef.current.setSegmentAction('deleteSegment');
              break; 
          case 'smoothBezier':
                canvasRef.current.setSegmentAction('smoothBezier');
                break;      
          case 'straight':
                canvasRef.current.setSegmentAction('straight');
                break;        
      }

      onClipBoardRef.current = false;
      setContextMenu(null);
      setDataChanged(true);
  
      return;
    }

    if(selectedRect.length === 0)
    {
      let closeContext = false;
      switch(action)
      {
        case 'pageSettings':
          setMenuModalOpen(true);
          closeContext = true;
          break;
        case 'copyPage':
          handleCopyModal();
          setOperation("select");  
          console.log("Initiating a copy from");
          closeContext = true;
          break;  
      }
      if(closeContext === true)
      {
        onClipBoardRef.current = false;
        setContextMenu(null);
        setDataChanged(true);
      }
  
    }

    if ((selectedRect.length==0 || !canvasRef.current) && onClipBoardRef.current ===false) return;

    switch (action) {
      case 'move':
        setOperation('move');
        break;
      case 'resize':
        setOperation('resize');
        break;
      case 'clip':
        // handleListImages();
        handleImageSelect(true);
        setOperation("select");
        break;
      case 'delete':
        canvasRef.current.deleteSelectedRect();
        setSelectedRect([]);
        selectedRectRef.current = [];
        setRectData({ id: '', description: '', type: '', subType:'Custom', imageName:'', richText:'', plainText:'', zIndex: '' });
        setOperation('select');
        break;
      case 'copy':
        canvasRef.current.duplicateRect();
        break;
      case 'alignTop':
        canvasRef.current.alignTop();
        break;
      case 'alignLeft':
        canvasRef.current.alignLeft();
        break;
      case 'alignRight':
        canvasRef.current.alignRight();
        break;
      case 'alignBottom':
        canvasRef.current.alignBottom();
        break;
      case 'groupTogether':
          canvasRef.current.groupTogether();
          break;  
      case 'ungroup':
            canvasRef.current.ungroup();
            break;    
      case 'convertToBezier':
              canvasRef.current.convertToBezier(selectedRect);
              break;      
      case 'expandLeft':
          canvasRef.current.expandLeft();
          break;
      case 'expandRight':
          canvasRef.current.expandRight();
          break;
      case 'expandUp':
          canvasRef.current.expandUp();
          break;
      case 'expandDown':
          canvasRef.current.expandDown();
          break;
                      
      case 'back':
        canvasRef.current.pushToBack();
        break;
      case 'front':
          canvasRef.current.pushToFront();
          break;
      case 'copyTo':
        canvasRef.current.copyTo();
        break;
      case 'lock':
          canvasRef.current.lock(selectedRect);
          break;  
      case 'lockAll':
            canvasRef.current.lockAll(selectedRect);
            break;  
      case 'unLockAll':
            canvasRef.current.unLockAll(selectedRect);
            break;  
  
      case 'rotate':
          rotate();
          break;     
      case 'flipV':
        canvasRef.current.flipV(selectedRect[0]);
        break;
      case 'flipH':
        canvasRef.current.flipH(selectedRect[0]);
        break;
      case 'paste':
        console.log("Paste is hit");
        canvasRef.current.paste();
        break;
      case 'clearC':
        canvasRef.current.clearClip();
        break;
      case 'explodeB':
        canvasRef.current.explodeBezier();
        break;
      case 'explode':
          canvasRef.current.explodePline();
          break;
      case 'htmlEditor':
          handleHtmlEditor();
          setOperation("select");
          break;
      case 'link':
          handleLinkModal();
          setOperation("select");
          break;  
      case 'imageSelect':
          handleImageSelect(false);
          setOperation("select");
          break;
      case 'imageAdjust':
          canvasRef.current.adjustImage();
          break;
      case 'aiPrompt':
          handleAiPrompt("vector");
          setOperation("select");
          break;
      case 'aiImagePrompt':
            handleAiPrompt("image");
            setOperation("select");
            break; 
      case 'aiModifyImagePrompt':
            handleAiPrompt("image");
            setOperation("select");
            break;
      case 'aiGenerateCode':
              handleAiPrompt("code");
              setOperation("select");
              break;            
      case 'aiEditCode':
              handleAiEdit();
              setOperation("select");
              break;              
      case 'animateSettings':
            openAnimateDialog();                        
            break;          
      case 'settings':
            openSettingDialog();            
            break;            
      case 'effects':
            openEffectsDialog();                        
            break;           
      case 'emoji':            
            openSvgGlyphDialog();
            break;
      case 'exportSvg':            
          exportSvg(selectedRect[0]);
          break;
      case 'exportCode':            
          exportCode(selectedRect[0]);
          break;

      case 'importSvg':            
          importSvg(selectedRect[0]);          
          break;  
    }

    onClipBoardRef.current = false;
    setContextMenu(null);
    setDataChanged(true);
        
  };

  function handlePageHeight(e)
  {    
      const val = e.target.value;
      setPageHeight(val === '' ? '' : +val);

      pagesRef.current.pages[currentPage-1].pageHeight = val;   
      setDataChanged(true);
  }


  function finalizePageWidth(width)
  {

      
    // Find initial device type
     const currentDevice = devicesRef.current.find(
            device => device.name === deviceId
          );

    const numberValue = Number(width);


    if (!isNaN(numberValue) && currentDevice) 
    {

      if(numberValue > currentDevice.minWidth && numberValue <= currentDevice.maxWidth)
      {
        setPageWidthExt(numberValue);
        pagesRef.current.pages[currentPage-1].pageWidth =numberValue;
      }
      else
      {
            // setPageWidthExt(currentDevice.maxWidth);
            setPageWidthExt(currentDevice.minWidth);
             let text = `Change device because your width is out of range for this device: ${currentDevice.name} has minimum width of ${currentDevice.minWidth} and maximum width of ${currentDevice.maxWidth}`

              Swal.fire({
                title: 'Info',
                text: text,
                icon: 'info',
                confirmButtonText: 'OK',
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,    
              });                    
        
            return;
        
      }
  
    }
    console.log("numbervalue: ", numberValue);
    console.log("name: ", deviceId);    
  }

  function setPageWidthExt(width)
  {
    setPageWidth(width);
    setPageWidthStr(width.toString());
  }

  function handlePageWidth(e)
  {
    const val = e.target.value;    
    setPageWidthStr(val === '' ? '' : +val);  
    setDataChanged(true);
  }

  function handleNavigationChange(e)
  {
    setMethodExt(e.target.value);
    navigationRef.current.method = e.target.value;
    setDataChanged(true);
  }

  function setButtonStates(cp)
  {
    if(canvasRef.current.canUndo(cp))
    {
      setCanUndo(true);
    }
    else
    {
      setCanUndo(false);
    }

    if(canvasRef.current.canRedo(currentPage))
    {
      setCanRedo(true);
    }
    else
    {
      setCanRedo(false);
    }

    if(canvasRef.current.canSave(currentPage))
    {
      canSaveRef.current=true;
      // setCanSave(true);
    }
    else
    {
      canSaveRef.current= false;
      // setCanSave(false);
    }
  }
  function handleNextPage()
  {
    // canvasRef.current.savePageHistory(currentPage);
    setCurrentPage(currentPage + 1);
    
    let nextIndex = currentPage;

    const page = pagesRef.current.pages[nextIndex];
    canvasRef.current.setRectangles(page.layout);        
    canvasRef.current.setPageInfo(page.pageInfo);

    setPageWidthExt(page.pageWidth);
    setPageHeight(page.pageHeight);
    setPageId(page.pageId);
    setDeviceId(page.deviceId);

    setButtonStates(currentPage + 1);
    // canvasRef.current.clearHistory();
  }

  function handlePrevPage()
  {
   // canvasRef.current.savePageHistory(currentPage);
    setCurrentPage(currentPage - 1);
    let prevIndex = currentPage -2;
    const page = pagesRef.current.pages[prevIndex];
    canvasRef.current.setRectangles(page.layout);
    canvasRef.current.setPageInfo(page.pageInfo);

    setPageWidthExt(page.pageWidth);
    setPageHeight(page.pageHeight);
    setPageId(page.pageId);
    setDeviceId(page.deviceId);

    setButtonStates(currentPage - 1);

    // canvasRef.current.clearHistory();
  }
  
  function fixOrRemovePageReferences(pageId) {
    const [prefix, numStr] = pageId.split("_");
    const number = parseInt(numStr, 10);
  
    // Find first occurrence of pageId
    const firstIndex = devicesRef.current.findIndex(device =>
      pagesForDeviceRef.current[device.name].some(page => page.id === pageId)
    );
    if (firstIndex === -1) return; // Nothing to remove
  
    // Look backward for lower-numbered version of same prefix
    let replacementId = null;
    for (let i = firstIndex - 1; i >= 0; i--) {
      const arr = pagesForDeviceRef.current[devicesRef.current[i].name];
      const match = arr.find(page => {
        const [p, n] = page.id.split("_");
        return p === prefix && parseInt(n, 10) < number;
      });
      if (match) {
        replacementId = match.id;
        break;
      }
    }
  
    // Purge all instances of pageId from every device array
    devicesRef.current.forEach(device => {
      const arr = pagesForDeviceRef.current[device.name];
      for (let i = arr.length - 1; i >= 0; i--) {
        if (arr[i].id === pageId) {
          arr.splice(i, 1);
        }
      }
    });
  
    // If a replacement exists, fill from its device onward
    if (replacementId) {
      const replacementDeviceIndex = devicesRef.current.findIndex(device =>
        pagesForDeviceRef.current[device.name].some(page => page.id === replacementId)
      );
      setDeviceInfo(replacementId, devicesRef.current[replacementDeviceIndex].name);
    }
  }
  

  /*
  function fixOrRemovePageReferences(pageId) {
    const [prefix, numStr] = pageId.split("_");
    const number = parseInt(numStr, 10);
  
    // Find first occurrence of pageId
    const firstIndex = devicesRef.current.findIndex(device =>
      pagesForDeviceRef.current[device.name].includes(pageId)
    );
    if (firstIndex === -1) return; // Nothing to remove
  
    // Look backward for lower-numbered version of same prefix
    let replacementId = null;
    for (let i = firstIndex - 1; i >= 0; i--) {
      const arr = pagesForDeviceRef.current[devicesRef.current[i].name];
      const match = arr.find(id => {
        const [p, n] = id.split("_");
        return p === prefix && parseInt(n, 10) < number;
      });
      if (match) {
        replacementId = match;
        break;
      }
    }
  
    // Purge all instances of pageId from every device array
    devicesRef.current.forEach(device => {
      const arr = pagesForDeviceRef.current[device.name];
      for (let i = arr.length - 1; i >= 0; i--) {
        if (arr[i] === pageId) {
          arr.splice(i, 1);
        }
      }
    });
  
    // If a replacement exists, fill from its device onward
    if (replacementId) {
      const replacementDeviceIndex = devicesRef.current.findIndex(device =>
        pagesForDeviceRef.current[device.name].includes(replacementId)
      );
      setDeviceInfo(replacementId, devicesRef.current[replacementDeviceIndex].name);
    }
  }
  */
  
  function handleDeletePage()
  {
    console.log("Deleting page");
    if(pagesRef.current.pages.length > 1)
    {
      // pagesRef.current.pages.pop();
      const page = pagesRef.current.pages[currentPage-2];
      canvasRef.current.setRectangles(page.layout);
      canvasRef.current.setPageInfo(page.pageInfo);


      const deletedPage = pagesRef.current.pages[currentPage-1];
      fixOrRemovePageReferences(deletedPage.pageId)

      pagesRef.current.pages.splice(currentPage-1, 1);
      let total = pagesRef.current.pages.length;

      
      setCurrentPage(currentPage-1);      
      setTotalPages(total);  

      setPageWidthExt(pagesRef.current.pages[currentPage-2].pageWidth);
      setPageHeight(pagesRef.current.pages[currentPage-2].pageHeight);  
      setPageId(pagesRef.current.pages[currentPage-2].pageId);
      setDeviceId(pagesRef.current.pages[currentPage-2].deviceId);

      canvasRef.current.clearHistory();
      setRefreshToggle(prev => !prev);
      setOperation('select');
      setDataChanged(true);
    }
  }


  function getPrefix(prefix)
  {

    const filtered =pagesRef.current.pages.filter(page=> {
         const [p,n] = page.pageId.split("_");
         return p===prefix;        
    })
    return filtered;
  }

  function handleMenuInfo(e)
  {
    setMenuModalOpen(true)    
  }

  function handlePageType(e)
  {
    if(e.target.value === deviceId) return;    
    
    const cp = pagesRef.current.pages[currentPage-1];

    let pageId = cp.pageId;

    const deviceIndex = devicesRef.current.findIndex(device => device.name === e.target.value);
    const [prefix, number] = pageId.split("_");

    const pd = getPrefix(prefix);
    
    let newId = `${prefix}_${deviceIndex}`;

    // make sure you don't do anything if page already exists

    const page = pagesRef.current.pages.find(page=>page.pageId === newId);

    if(page != undefined)
    {
      console.log("This page already exists") ;
      return;
    }

    console.log("newId: ", newId);
    setDeviceInfo(newId, e.target.value);

    let p = [];

    const deviceObj = devicesRef.current.find(device => device.name === e.target.value);

    let pageInfo = {name: `${prefix}}`,
                    pageTheme: "",
                    browserBackground:"#dddddd",
                    pageBackground:"#ffffff",
                    fillMode:"solid",
                    gradientColor1: "#ffffff",
                    gradientColor2: "#000000",
                    gradientAngle:  0,                
                    marginTop: 10,
                    marginBottom:10
                };
                                            
    // let newPage = {pageWidth:deviceObj.maxWidth, pageHeight:pageHeight, pageId:newId, deviceId:e.target.value, pageInfo:pageInfo, layout:[]};
    let newPage = {pageWidth:deviceObj.minWidth, pageHeight:pageHeight, pageId:newId, deviceId:e.target.value, pageInfo:pageInfo, layout:[]};
    canvasRef.current.setRectangles(newPage.layout);
    canvasRef.current.setPageInfo(newPage.pageInfo);

    let currentIndex = pagesRef.current.pages.findIndex(page => {
      const [p, n] = page.pageId.split("_");
      if(p===prefix)
      {
        return true;
      }
    });

    if (pd.length > 0) {
      let inserted = false;
    
      for (let i = 0; i < pd.length; i++) {
        const [p, existingIndex] = pd[i].pageId.split("_");
        const existingIndexNum = Number(existingIndex);
        const deviceIndexNum = Number(deviceIndex);
    
        console.log("currentIndex:", currentIndex);
        console.log("existingIndex:", existingIndexNum);
        console.log("deviceIndex:", deviceIndexNum);
        console.log("i:", i);
    
        if (existingIndexNum >= deviceIndexNum) {
          // Insert before this page
          currentIndex += (i === 0 ? 0 : i - 1);
          inserted = true;
          break;
        }
      }
    
      // If we never found a larger index, insert at the end
      if (!inserted) {
        currentIndex += pd.length - 1; // last page
      }
    }
    
    // newPage.layout = pagesRef.current.pages[current.index].layout;
    //This copies info from lower device type to the wider device automatically
    newPage.layout = JSON.parse(JSON.stringify(pagesRef.current.pages[currentIndex].layout));
    newPage.pageInfo = pagesRef.current.pages[currentIndex].pageInfo;

    if (currentIndex >= 0) {
      // Insert after the current page
      pagesRef.current.pages.splice(currentIndex + 1, 0, newPage);

    } else {
      // If not found, optionally push to the end
      pagesRef.current.pages.push(newPage);

    }

    // pagesRef.current.pages.push(newPage);

    let total = pagesRef.current.pages.length;
    
    setCurrentPage(currentIndex + 2);
    setTotalPages(total);

    setPageWidthExt(pagesRef.current.pages[currentIndex+1].pageWidth);
    setPageHeight(pagesRef.current.pages[currentIndex+1].pageHeight);

    setPageId(pagesRef.current.pages[currentIndex+1].pageId);

    setDeviceId(e.target.value);

    canvasRef.current.clearHistory();
    canvasRef.current.setRectangles(newPage.layout);
    canvasRef.current.setPageInfo(newPage.pageInfo);
    // canvasRef.current.redraw();    
    setOperation('select');
    return;
  
  }


  function handleAddPage()
  {


    let id = getUnique(unique);

    let pageId = `${id}_0`;
    let deviceId = devicesRef.current[0].name;

    setPageId(pageId);
    setDeviceId(deviceId);
    setDeviceInfo(pageId,deviceId);
    setUnique(id);

    // let p = [];



    let pageInfo = {name: `${id}`,
                    pageTheme: "",
                    browserBackground:"#dddddd",
                    pageBackground:"#ffffff",
                    fillMode:"solid",
                    gradientColor1: "#ffffff",
                    gradientColor2: "#000000",
                    gradientAngle:  0,                
                    marginTop: 10,
                    marginBottom:10
                };

    // let newPage = {pageWidth:devicesRef.current[0].maxWidth, pageHeight:pageHeight, pageId:pageId, deviceId:deviceId, pageInfo:pageInfo, layout:[]};
      let newPage = {pageWidth:432, pageHeight:pageHeight, pageId:pageId, deviceId:deviceId, pageInfo:pageInfo, layout:[]};

/*
      let newPage = {pageWidth: pageWidth,
          pageHeight: pageHeight,
          layout: []}
          */

      canvasRef.current.setRectangles(newPage.layout);
      canvasRef.current.setPageInfo(newPage.pageInfo);
      pagesRef.current.pages.push(newPage);      
      let total = pagesRef.current.pages.length;
      
      setCurrentPage(total);
      
      setTotalPages(total);

      setPageWidthExt(pagesRef.current.pages[total-1].pageWidth);
      setPageHeight(pagesRef.current.pages[total-1].pageHeight);
      
      canvasRef.current.clearHistory();
      setOperation('select');
      return;
  }

  function handleHtmlChange(html, text)
  {
    
    if(selectedRect.length === 1)
    {
      // selectedRect[0].imageName = fileName;
      // selectedRect[0].richText = `<![CDATA [${html}]]>`;
      selectedRect[0].richText=html;
      selectedRect[0].plainText=text;
      setDataChanged(true);
      setRectData(selectedRect[0]);      
    }

  }

  async function handleListImages()
  {  
    await getImageResources();
    setIsImageModalOpen(true)  
  }


function handleDrawChange(op)
{

  if(op === 'newline')
  {
    canvasRef.current.newPolyline();      
    return;
  }
  if(op === 'clearlines')
  {
    canvasRef.current.clearPoints();
    return;
  }
  if(op === 'finalize')
  {
    if(operationRef.current === 'bezier')
    {
      canvasRef.current.finalizeBezier();      
    }
    if(operationRef.current === 'pline' || operationRef.current === 'freehand')
    {
      canvasRef.current.finalizePolyline();      
    }

    canvasRef.current.saveLine(operationRef.current);

    return;
  }
  if(op === 'undoline')
  {
    console.log("Doing undo line");

    if(operationRef.current === 'bezier')
    {
      canvasRef.current.undoBezier();
    }    
    if(operationRef.current === 'pline')
    {
      canvasRef.current.undoPline();
    }    
    if(operationRef.current === 'freehand')
    {
      canvasRef.current.undoFreeHand();
    }

    return;
  }

  if(op === 'exitline')
  {
    canvasRef.current.saveLine(operationRef.current);
    operationRef.current = 'select'      
    setOperation('select');
    setRefreshToggle(prev => !prev);
    canvasRef.current.redraw();
  }

  if(op === 'restore')
  {

    canvasRef.current.restoreLine(operationRef.current);
    canvasRef.current.redraw();
  }

}
  

function renderDrawButtons({  
    operation,
    handleDrawChange})
{
  const operations = ["restore", "newline", "undoline", "clearlines", "finalize", "exitline"]


    return (
      <div className="operation-buttons-d">
        <h4 style ={{marginBottom:'16px', width:'100%'}}> {operationRef.current}</h4>        
        {operations.map((op) => {
          const isDisabled = segmentOpRef.current==='lineop' && op !== "undoline" ? true: false;

          const iconEntry = iconMapDraw[op];            
          const icon = iconEntry?.icon || op;
          const title = iconEntry?.title || op;
  
          const classNames = [
            'operation-button-d',
            operation === op ? 'active' : '',
            isDisabled ? 'disabled' : '',
          ]
            .filter(Boolean)
            .join(' ');
  
          return (
            <button
              key={op}
              onClick={() => handleDrawChange(op)}
              disabled={isDisabled}
              className={classNames}
              title={title}
            >
              {icon}
            </button>
          );
        })}
      </div>
    );
}

function renderOperationButtons({
  filename,
  operation,
  handleOperationChange,
  canUndo,
  canRedo,
  canSave,
  dataChanged,
}) {
  const baseOps = ['new', 'open'];
  const extraOps = [
    'new', 'open', 'rect', 'image', 'aiart', 'airect', 'animate',' svgtext', 'svgemoji', 'svgcircle','svgellipse','svgrect','svgsquare','pline', 'freehand', 
    'bezier', 'select', 'undo', 'redo', 'clear', 'preview', 'previewCode',' save'
  ];
  const operations = filename === '' ? baseOps : extraOps;


  
  return (
    <div className="operation-buttons">
      {Object.keys(iconMap).map((sectionKey) => {
        const sectionOps = iconMap[sectionKey]; // Get operations for the current section
        return (
          <div key={sectionKey} className="button-section">
            <h5 className="section-title">
              {sectionKey.replace(/([A-Z])/g, ' $1')} {/* Title for the section */}
            </h5>
            <div className="button-group">
              {sectionOps.map((op) => {
                const isDisabled =
                  (op.key === 'undo' && !canUndo) ||
                  (op.key === 'redo' && !canRedo) ||
                  (op.key === 'save' && !canSaveRef.current && !dataChanged);

                const icon = op.icon;
                const title = op.title;

                const classNames = [
                  'operation-button',
                  operation === op.key ? 'active' : '',
                  isDisabled ? 'disabled' : '',
                ]
                  .filter(Boolean)
                  .join(' ');

                return (
                  <button
                    key={op.key}
                    onClick={() => handleOperationChange(op.key)}
                    disabled={isDisabled}
                    className={classNames}
                    title={title}
                    data-help={op.key}
                    onMouseEnter={(e) => { 
                      handleEnter(e)}}
                    onMouseLeave={(e) => { 
                        handleLeave(e) 
                      }}
                  >
                    {op?.type === 'url' ? (
                        <img src={op.icon} width={18} height={18} style={{ objectFit: 'contain',    transform: 'scale(2)' }}/>
                      ) : (
                        op.icon
                      )}
                  </button>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}

/*
function renderOperationButtons({
    filename,
    operation,
    handleOperationChange,
    canUndo,
    canRedo,
    canSave,
    dataChanged,
  }) {
    const baseOps = ['new', 'open'];
    const extraOps = ['new', 'open', 'rect', 'image', 'airect','svgtext','pline', 'freehand', 'bezier','select', 'undo', 'redo', 'clear', 'preview', 'save', 'savehtml', 'saveai'];
    const operations = filename === '' ? baseOps : extraOps;

  
    return (
      <div className="operation-buttons">
        {operations.map((op) => {
          const isDisabled =
            (op === 'undo' && !canUndo) ||
            (op === 'redo' && !canRedo) ||
            (op === 'save' && !canSaveRef.current && !dataChanged);

          const iconEntry = iconMap[op];            
          const icon = iconEntry?.icon || op;
          const title = iconEntry?.title || op;
  
          const classNames = [
            'operation-button',
            operation === op ? 'active' : '',
            isDisabled ? 'disabled' : '',
          ]
            .filter(Boolean)
            .join(' ');
  
          return (
            <button
              key={op}
              onClick={() => handleOperationChange(op)}
              disabled={isDisabled}
              className={classNames}
              title={title}
              data-help={`${op}`}
              onMouseEnter = {(e)=>{handleEnter(e)}}              
              onMouseLeave = {(e)=>{handleLeave(e)}}              
            >
              {icon}
            </button>
          );
        })}
      </div>
    );
  }
*/

  function gridHeightInput(e) {    
    let value = e.target.value;
        
    // const value = Number(e.target.value); // convert to number
      
    /*
    if (Number(value) < 10)
    {
      setGridHeight(10);
      return;
    }
    
    if(Number(value)> 50) 
    {
      
      setGridHeight(50);
      return;
    }
    */
      
    setGridHeight(value);
    canvasRef.current.redraw();
  }
  

  function gridWidthInput(e) { 
    let value = e.target.value;   

    /*
    if (Number(value) < 10)
    {
      setGridWidth(10);
      return;
    }
    
    if(Number(value)> 50) 
    {
      
      setGridWidth(50);
      return;
    }
    */

    /*
    const value = Number(e.target.value); // convert to number
  
    if (isNaN(value) || value < 10 || value > 50) {
      return; // invalid input
    }
    */
    setGridWidth(value);
    canvasRef.current.redraw();
  }
  
  
  function renderOps()
  {

    if(operationRef.current === 'pline' )
    {
        return [renderDrawButtons({
          operation,
          handleDrawChange}),
          renderForDrawTools()];          
    }

    if(operationRef.current === 'freehand' )
    {
      return [renderDrawButtons({
        operation,
        handleDrawChange}),
        renderForDrawTools()];
    }

    if(operationRef.current === 'bezier' )
    {
      return [renderDrawButtons({
        operation,
        handleDrawChange}),
        renderForDrawTools()];
    }

    return [renderOperationButtons({
      filename,
      operation,
      handleOperationChange,
      canUndo,
      canRedo,
      canSave,
      dataChanged
    }),renderPLineInput()];

    
  }

  function renderEndControls(checkboxLabelStyle)
  {
    if(operationRef.current === 'bezier')
    {
      return(<div>
          <label style={checkboxLabelStyle}>
          <input
            type="checkbox"
            checked={showEndPoints}
            onChange={(e) => setShowEndPoints(e.target.checked)}
          />
          Show End Points
        </label>

        <label style={checkboxLabelStyle}>
          <input
            type="checkbox"
            checked={showControls}
            onChange={(e) => setShowControls(e.target.checked)}
          />
          Show Control Points
        </label>
      </div>)


    }
    if(operationRef.current === 'pline')
    {
      return(<div>
        <label style={checkboxLabelStyle}>
        <input
          type="checkbox"
          checked={showEndPoints}
          onChange={(e) => setShowEndPoints(e.target.checked)}
        />
        Show End Points
      </label>
      </div>)
    }

    return (<div></div>)
  }
  function renderForDrawTools() {
    const containerStyle = {
      display: 'flex',
      flexDirection: 'column',
      gap: '6px', // Slight vertical spacing between rows
    };
  
    const rowStyle = {
      display: 'flex',
      alignItems: 'center',
      gap: '6px', // Space between label and input
    };
  
    const labelStyle = {
      fontSize: '14px',
      minWidth: '60px', // Ensure label width is consistent
    };
  
    const inputStyle = {
      fontSize: '14px',
      padding: '4px 6px',
      border: '1px solid #ccc',
      borderRadius: '5px',
      width: '60px', // Enough for ~5 digits
      height: '28px',
    };
  
    const colorInputStyle = {
      padding: '0',
      border: 'none',
      width: '40px',
      height: '28px',
    };
  
    const checkboxLabelStyle = {
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
    };
  
    return (
      <div style={containerStyle}>
        {/* Grid Width */}
        <div style={rowStyle}>
          <label style={labelStyle}>Grid W:</label>
          <input
            style={inputStyle}
            type="number"
            value={gridWidth}
            onChange={gridWidthInput}
          />
        </div>
  
        {/* Grid Height */}
        <div style={rowStyle}>
          <label style={labelStyle}>Grid H:</label>
          <input
            style={inputStyle}
            type="number"
            value={gridHeight}
            onChange={gridHeightInput}
          />
        </div>

        <div style={rowStyle}>          
          <label style={labelStyle}>Opacity:</label>

          <input
            style={inputStyle}
            type="number"
            min="0"
            max="1"
            step="0.01"
            value={alpha}
            onChange={(e) => {
              const val = e.target.value;

              if (val === '') {
                setAlpha('');
                return;
              }

              const num = Math.max(0, Math.min(1, +val)); // clamp 0–1
              setAlpha(num);
            }}
          />
        </div>
    
        {/* Stroke */}
        <div style={rowStyle}>
          <label style={labelStyle}>Stroke W:</label>
          <input
            style={inputStyle}
            type="number"
            value={stroke}
            onChange={(e) => {
              const val = e.target.value;
              setStroke(val === '' ? '' : +val);
            }}
          />
        </div>
  
        {/* Color Inputs */}
        <div style={rowStyle}>
          <label style={labelStyle}>Stroke C:</label>
          <input
            style={colorInputStyle}
            type="color"
            value={strokeColor}
            onChange={(e) => setStrokeColor(e.target.value)}
          />
        </div>
  
        <div style={rowStyle}>
          <label style={labelStyle}>Fill:</label>
          <input
            style={colorInputStyle}
            type="color"
            value={fillColor}
            onChange={(e) => setFillColor(e.target.value)}
          />
        </div>

        {/* Checkboxes */}
        <label style={checkboxLabelStyle}>
          <input
            type="checkbox"
            checked={enableStroke}
            onChange={(e) => setEnableStroke(e.target.checked)}
          />
          Enable Stroke
        </label>

        {/* Checkboxes */}
        <label style={checkboxLabelStyle}>
          <input
            type="checkbox"
            checked={enableFill}
            onChange={(e) => setEnableFill(e.target.checked)}
          />
          Enable Fill
        </label>

  
        {/* Checkboxes */}
        <label style={checkboxLabelStyle}>
          <input
            type="checkbox"
            checked={snapToGrid}
            onChange={(e) => setSnapToGrid(e.target.checked)}
          />
          Snap to Grid
        </label>
  
        <label style={checkboxLabelStyle}>
          <input
            type="checkbox"
            checked={clipBoard}
            onChange={(e) => setClipBoard(e.target.checked)}
          />
          Clip Board
        </label>

        {renderEndControls(checkboxLabelStyle)}

      </div>
    );
  }


  function renderPLineInput() {
    const containerStyle = {
      display: 'flex',
      flexDirection: 'column',
      gap: '6px', // Slight vertical spacing between rows
    };
  
    const rowStyle = {
      display: 'flex',
      alignItems: 'center',
      gap: '6px', // Space between label and input
    };
  
    const labelStyle = {
      fontSize: '14px',
      minWidth: '60px', // Ensure label width is consistent
    };
  
    const inputStyle = {
      fontSize: '14px',
      padding: '4px 6px',
      border: '1px solid #ccc',
      borderRadius: '5px',
      width: '60px', // Enough for ~5 digits
      height: '28px',
    };
  
    const colorInputStyle = {
      padding: '0',
      border: 'none',
      width: '40px',
      height: '28px',
    };
  
    const checkboxLabelStyle = {
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
    };
  
    return (
      <div style={containerStyle}>
        {/* Grid Width */}
        <div style={rowStyle}>
          <label style={labelStyle}>Grid W:</label>
          <input
            style={inputStyle}
            type="number"
            value={gridWidth}
            onChange={gridWidthInput}
          />
        </div>
  
        {/* Grid Height */}
        <div style={rowStyle}>
          <label style={labelStyle}>Grid H:</label>
          <input
            style={inputStyle}
            type="number"
            value={gridHeight}
            onChange={gridHeightInput}
          />
        </div>
    
        {/* Checkboxes */}
        <label style={checkboxLabelStyle}>
          <input
            type="checkbox"
            checked={snapToGrid}
            onChange={(e) => setSnapToGrid(e.target.checked)}
          />
          Snap to Grid
        </label>
  
        <label style={checkboxLabelStyle}>
          <input
            type="checkbox"
            checked={clipBoard}
            onChange={(e) => setClipBoard(e.target.checked)}
          />
          Clip Board
        </label>
      </div>
    );
  }
  

  return (
      <div className="layout-container">
      {/* Left Panel */}
      <div className="left-panel">
        <div className="form-container">
          <div className="dimensions"
           data-help="PageDimensions"
           title="Page Width and Height"
           onMouseEnter={(e) => handleEnter(e)}
           onMouseLeave={(e) => handleLeave(e)}
          >
            <p>
              W: {pageWidth} H: {pageHeight}
            </p>
          </div>
          
          <label
              data-help="Navigation"
              title="Browser Navigation Type"
              onMouseEnter={(e) => handleEnter(e)}
              onMouseLeave={(e) => handleLeave(e)}
          
          >
            Navigation:
            <select
              className="number-input"
              value={method}
              onChange={handleNavigationChange}
            >
              <option value="scroll">Scroll</option>
              <option value="linked">Linked</option>
              {/* <option value="menu">Menu</option> */}
            </select>
          </label>

          {renderOps()}
          {/*renderPLineInput()*/}
        </div>
      </div>

      {/* Center Panel (Canvas) */}
      <div className="center-panel">
        <RibbonMenu
          currentPage={currentPage}
          totalPages={totalPages}
          onAddPage={handleAddPage}
          onPrevPage={handlePrevPage}
          onNextPage={handleNextPage}
          onPageChange={(pageNum) => setCurrentPage(pageNum)}
          onDeletePage = {handleDeletePage}
          onPageType = {handlePageType}
          operation={operation}   
          filename = {filename + '.ait'}
          x={coords.x}
          y={coords.y}
          selected = {selectedRect}
          pageId = {pageId}
          devices = {devicesRef.current}
          pageType = {deviceId}
          pageWidth = {pageWidth}
          hoverEnter = {handleEnter}
          hoverLeave = {handleLeave}
        />
        <Canvas
          key={canvasKey}
          ref={canvasRef}
          auth={auth}
          pagesRef={pagesRef}
          operation={operation}
          onCoordUpdate={handleCoordUpdate}
          onRectSelect={handleRectSelect}
          onAnimateSelect = {handleAnimateSelect}
          setOperation={setOperation}
          segmentOpRef= {segmentOpRef}
          pASegmentRef = {pASegmentRef}
          animateOpRef = {animateOpRef}
          setCanUndo={setCanUndo}
          setCanRedo={setCanRedo}
          setCanSaveFunc={setCanSaveFunc}
          setRefreshKey={setRefreshKey}
          filename={filename}
          pageWidth={pageWidth}
          pageHeight={pageHeight}
          gridWidth={gridWidth}
          gridHeight={gridHeight}
          stroke={stroke}
          strokeColor={strokeColor}
          fillColor={fillColor}
          allowStroke = {enableStroke}
          allowFill = {enableFill}
          fillMode = {fillMode}
          gradientColor1 = {gradientColor1}
          gradientColor2 = {gradientColor2}
          gradientAngle = {gradientAngle}
          alpha = {alpha}
          snapToGrid={snapToGrid}
          clipBoard = {clipBoard}
          showControls = {showControls}
          showEndPoints = {showEndPoints}
          demo = {demo}
          pageNum={currentPage}
        />
      </div>

      <div className = "right-panel">
          <div className="inner-panel">

            <div className="help-toolbar">
              <button
                className={`help-toggle-button ${showShortCuts ? 'active' : ''}`}
                onClick={() => setShowShortCuts(prev => !prev)}
                title={showShortCuts ? 'Show help' : 'Show shortcuts'}
              >
                <span className="help-toggle-icon">
                  {showShortCuts ? '❔' : '⌨️'}
                </span>

                <span>
                  {showShortCuts ? 'Help' : 'Gestures & Shortcuts'}
                </span>
              </button>
            </div>

            <div className="help-content">
              {showShortCuts
                ? <ShortCuts mode={operationRef.current}/>
                : (HELP_CONTENT[activeHelpKey] || DEFAULT_HELP)
              }
            </div>

          </div>
        </div>

        {/*
      <div className="right-panel">
        
        <div className="help-toolbar">
          <button
            className={`help-toggle-button ${showShortCuts ? 'active' : ''}`}
            onClick={() => setShowShortCuts(prev => !prev)}
            title={showShortCuts ? 'Show help' : 'Show shortcuts'}
          >
            <span className="help-toggle-icon">
              {showShortCuts ? '❔' : '⌨️'}
            </span>

            <span>
              {showShortCuts ? 'Help' : 'Gestures & Shortcuts'}
            </span>
          </button>
        </div>

        {showShortCuts
          ? <ShortCuts mode={operationRef.current}/>
          : (HELP_CONTENT[activeHelpKey] || DEFAULT_HELP)
        }

      </div>
      */}

    
      {/* Context Menu */}
      <ContextMenu        
        key={Date.now()}
        contextMenu={contextMenu}
        selectedRect={selectedRect}
        segments= {pSegmentsRef.current}
        aSegment = {pASegmentRef.current}  
        lines = {pLinesRef.current}
        onClipBoard = {onClipBoardRef.current}
        handleContextMenuAction={handleContextMenuAction}
      />

      {/* File Modal */}
      {isModalOpen && (
        <div className="modalM">
          <div className="modalM-content">
            <h2>Select a File</h2>
            <div className="file-list-container">
              <ul>
                {fileList.map((file) => (
                  <li key={file}>
                    <button onClick={() => handleOpenFile(file)}
                    disabled={loadingFile !== null}
                    >
                      {loadingFile === file ? (
                          <span className="spinner"></span>
                        ) : (
                          file
                        )}                    
                    </button>
                    
                  </li>
                ))}
              </ul>
            </div>
            {loadingFile === null && (
                  <button
                    className="close-button"
                    onClick={() => setIsModalOpen(false)}
                  >
                    Close
                  </button>
                )}
          </div>
        </div>
      )}

      {isHtmlEditorOpen && (
          <HtmlEditor
            isOpen={true}
            onClose={() => {  
                          // setOperation("select");                       
                          setIsHtmlEditorOpen(false);
                          isHtmlEditorOpenRef.current = false;
                          pauseDeleteRef.current = false;
                        }}
            onSave={onApplyHtmlEditor}
            rect = {selectedRectRef.current[0]} />            
      )}


      {isLinkModalOpen && (
          <LinkModal
            isOpen={true}
            onClose={() => {  
                          // setOperation("select");                       
                          setIsLinkModalOpen(false);
                          pauseDeleteRef.current = false;
                          isLinkModalOpenRef.current = false
                        }}
            onSave={onApplyLinkModal}
            selected = {selectedRectRef.current[0]} 
            pages = {pagesRef.current.pages}
            currentPage = {currentPage}
            />                        
      )}

    {isCopyModalOpen && (
          <CopyModal
            isOpen={true}
            onClose={() => {  
                          // setOperation("select");                       
                          setIsCopyModalOpen(false);
                          pauseDeleteRef.current = false;
                          isCopyModalOpenRef.current = false;
                        }}
            onSave={onApplyCopyModal}
            selected = {selectedRectRef.current[0]} 
            pages = {pagesRef.current.pages}
            />            
      )}




    {isAiPromptOpen && (
          <AiPrompt
            isOpen={true}
            onClose={() => {  
                          // setOperation("select");                       
                          setIsAiPromptOpen(false);
                          isAiPromptOpenRef.current = false;
                          pauseDeleteRef.current = false;
                        }}
            onSave={onApplyAiPrompt}
            onImage = {onApplyImagePrompt}
            onCode = {onApplyCodePrompt}
            promptType = {promptType}
            onLogout = {onLogout}
            auth = {auth}
            demo = {demo}
            aspectLock = {lockAspect}
            onScrollOpen = {handleScrollOpen}
            rect = {selectedRectRef.current[0]} />            
      )}
    {isAiEditOpen && (
      <AiEdit
            isOpen={true}
            onClose={() => {  
                          // setOperation("select");                       
                          setIsAiEditOpen(false);
                          isAiEditOpenRef.current = false;
                          pauseDeleteRef.current = false;
                        }}
            onSave={onApplyEdit}
            rect = {selectedRectRef.current[0]} 

          />
    )}      


    {isImageSelectOpen && (
          <ImageSelect
            id="image-select-dialog"
            isOpen={true}
            onClose={() => {  
                          // setOperation("select");                       
                          setIsImageSelectOpen(false);                          
                        }}
            onSave={onApplyImageSelect}
            onLogout = {onLogout}
            auth = {auth}
            demo = {demo}
            aspectLock = {lockAspect}
            rectData = {selectedRectRef.current[0]}
            onScrollOpen = {handleScrollOpen} />            
      )}




      {/* File Modal */}
      {isImageModalOpen && (
        <div className="modalM">
          <div className="modalM-content">
            <h2>Select a Image</h2>
            <div className="file-list-container">
              <ul>
                {fileList.map((file) => (
                  <li key={file}>
                    <button onClick={() => handleOpenImage(file)}>{file}</button>
                  </li>
                ))}
              </ul>
            </div>
            <button className="close-button" onClick={() => setIsImageModalOpen(false)}>
              Close
            </button>
          </div>
        </div>
      )}


    <AnimateSettings
        isOpen={isAnimateDialogOpen}
        onClose={closeAnimateDialog}
        onSave={handleAnimateSave}
        mPathSelection = {handleMPathSelection}
        mObjectSelection = {handleMObjectSelection}
        onOffsetObj = {handleOffsetObj}
        onOffsetPath = {handleOffsetPath}
        onResizeView = {handleResizeView}
        rectData = {selectedRectRef.current[0]}
      />

    <SettingsDialog
        isOpen={isSettingDialogOpen}
        onClose={closeSettingDialog}
        onSave={handleSettingsSave}
        rectData = {selectedRectRef.current[0]}
        segments= {pSegmentsRef.current}
        aSegment = {pASegmentRef.current}  
        lines = {pLinesRef.current}
        onScrollOpen = {handleScrollOpen}
      />
    
    <SvgGlyphDialog
      isOpen = {isSvgGlyphDialogOpen}
      onClose = {closeSvgGlyphDialog}
      onSave = {saveNewGlyph}
      indexUrl="emoji.json"
      svgBaseUrl="https://myaiweb.ca/openmoji"
    />

    <EffectsDialog
        isOpen={isEffectsDialogOpen}
        onClose={closeEffectsDialog}
        onSave={handleEffectsSave}
        shadowData = {selectedRectRef.current[0]}
      />

      
      <MenuPageModal 
        currentPage = {currentPage}
        formDataInput = {pagesRef?.current?.pages?.[currentPage-1]?.pageInfo}
        isOpen={menuModalOpen}
        onClose={() => setMenuModalOpen(false)}        
        onSave = {handleMenuSave}
        pageId = {pageId}
        pageWidth = {pageWidth}
        pageHeight = {pageHeight}
      />

    </div>
  )

};

export default CreateTemplate;

